
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2rynm", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $jmjWc = parcelRequire("jmjWc");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $io723 = parcelRequire("io723");


var $gz8ZY = parcelRequire("gz8ZY");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");








var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $2W0qg = parcelRequire("2W0qg");


var $hmuev = parcelRequire("hmuev");


var $6xdDU = parcelRequire("6xdDU");


var $ep3mz = parcelRequire("ep3mz");


var $1I9Gw = parcelRequire("1I9Gw");













var $ccHMk = parcelRequire("ccHMk");


var $cO1el = parcelRequire("cO1el");


var $1Whri = parcelRequire("1Whri");


var $8tdj3 = parcelRequire("8tdj3");


var $auNCB = parcelRequire("auNCB");





var $eyWa4 = parcelRequire("eyWa4");







var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");


var $imt6g = parcelRequire("imt6g");


var $fPK4h = parcelRequire("fPK4h");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $jdPfT = parcelRequire("jdPfT");


var $7aA9P = parcelRequire("7aA9P");


var $lsxnT = parcelRequire("lsxnT");




/**
 * @generated SignedSource<<e1461337ea6e9b3d7422c03a23ca2cf9>>
 * @relayHash afe0901b48e911b10f7b851c09b7931f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bd98b03ab887daa0808adad76c005fcfdb15914d41890abaf26048a8b6fcda4f
const $ffebeb9f14c82074$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "ids",
                    "variableName": "ids"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentTitlesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentTitlesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afe0901b48e911b10f7b851c09b7931f",
            "id": "bd98b03ab887daa0808adad76c005fcfdb15914d41890abaf26048a8b6fcda4f",
            "metadata": {},
            "name": "useContentTitlesQuery",
            "operationKind": "query",
            "text": "query useContentTitlesQuery($ids:[ID!]!){content(ids:$ids){nodes{id,title}}}"
        }
    };
}();
$ffebeb9f14c82074$var$node.hash = "55f695ceabd6367765c49b523c7e2f29";
var $ffebeb9f14c82074$export$2e2bcd8739ae039 = $ffebeb9f14c82074$var$node;



var $jMyy4 = parcelRequire("jMyy4");

const $d765c8713688ab6e$var$ContentTitlesQuery = (0, $ffebeb9f14c82074$export$2e2bcd8739ae039);
const $d765c8713688ab6e$export$7610585fadab893e = (contentIds)=>{
    const $ = (0, $frIzR.c)(11);
    let t0;
    if ($[0] !== contentIds) {
        t0 = new Set(contentIds);
        $[0] = contentIds;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = [
            ...t0
        ].filter(Boolean);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    const unique = t1;
    const ids = unique;
    let t2;
    if ($[4] !== ids) {
        t2 = {
            ids: ids
        };
        $[4] = ids;
        $[5] = t2;
    } else t2 = $[5];
    const t3 = ids.length === 0;
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
        t4 = {
            variables: t2,
            skip: t3
        };
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    const { data: data } = (0, $jMyy4.useQueryInterop)($d765c8713688ab6e$var$ContentTitlesQuery, t4);
    let map;
    if ($[9] !== data?.content?.nodes) {
        map = new Map();
        const nodes = data?.content?.nodes ?? [];
        for (const node of nodes)if (node?.id != null) map.set(node.id, node.title ?? "");
        $[9] = data?.content?.nodes;
        $[10] = map;
    } else map = $[10];
    const titlesByContentId = map;
    return titlesByContentId;
};


var $090b31fb8b21ef86$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["SUGGEST"] = "SUGGEST";
    Action["ACCEPT"] = "ACCEPT";
    Action["REJECT"] = "REJECT";
    return Action;
}({});
const $090b31fb8b21ef86$export$51b10001420b4ba3 = [
    {
        pattern: 'docs.google.com/document',
        product: 'Google Docs',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png'
    },
    {
        pattern: 'docs.google.com/spreadsheets',
        product: 'Google Sheets',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_spreadsheet_x32.png'
    },
    {
        pattern: 'docs.google.com/presentation',
        product: 'Google Slides',
        iconUrl: 'https://ssl.gstatic.com/docs/presentations/images/favicon5.ico'
    },
    {
        pattern: 'drive.google.com',
        product: 'Google Drive',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png'
    },
    {
        pattern: 'loom.com',
        product: 'Loom',
        iconUrl: 'https://cdn.loom.com/assets/favicons-loom/favicon.ico'
    },
    {
        pattern: 'figma.com',
        product: 'Figma',
        iconUrl: 'https://static.figma.com/app/icon/1/favicon.ico'
    },
    {
        pattern: 'slack.com',
        product: 'Slack',
        iconUrl: 'https://slack.com/favicon.ico'
    }
];
const $090b31fb8b21ef86$export$9911254b1f812303 = {
    product: 'Link',
    iconUrl: ''
};

















const $c5ab38ff0f87742b$export$c035d51031d22758 = {
    google_drive: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png',
    google_docs: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png',
    google_sheets: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_spreadsheet_x32.png',
    google_slides: 'https://ssl.gstatic.com/docs/presentations/images/favicon5.ico',
    loom: 'https://cdn.loom.com/assets/favicons-loom/favicon.ico',
    figma: 'https://static.figma.com/app/icon/1/favicon.ico',
    slack: 'https://slack.com/favicon.ico'
};
const $c5ab38ff0f87742b$var$DEFAULT_ICON_URL = '';
function $c5ab38ff0f87742b$var$normalizeContentType(type) {
    return type.toLowerCase().replace(/\s+/g, '_');
}
function $c5ab38ff0f87742b$export$54e0f9305a4808e9(contentType) {
    const key = $c5ab38ff0f87742b$var$normalizeContentType(contentType);
    return $c5ab38ff0f87742b$export$c035d51031d22758[key] ?? $c5ab38ff0f87742b$var$DEFAULT_ICON_URL;
}
const $c5ab38ff0f87742b$var$styles = {
    wrapper: "_1e0c1txw _4cvr1h6o _1o9zidpf",
    iconSlot: "_2rko12b0 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _ahbqx0bf _kqswh2mm",
    iconSlotFirst: "_2rko12b0 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _ahbqidpf _kqswh2mm",
    smallIcon: "_1bsb7vkz _4t3i7vkz",
    largeIcon: "_1bsbvbgk _4t3ivbgk"
};
const $c5ab38ff0f87742b$var$ICON_SIZE = {
    small: 16,
    large: 64
};
const $c5ab38ff0f87742b$var$iconZIndex = (index, total)=>total - index;
const $c5ab38ff0f87742b$export$98526f0dffd4f41b = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { contentTypes: contentTypes, variant: t1, testId: t2 } = t0;
    const variant = t1 === undefined ? "small" : t1;
    const testId = t2 === undefined ? "stacked-content-type-icons" : t2;
    let T0;
    let t3;
    let t4;
    let t5;
    if ($[0] !== contentTypes || $[1] !== testId || $[2] !== variant) {
        const displayTypes = (contentTypes ?? []).slice(0, 3);
        const iconUrls = displayTypes.map($c5ab38ff0f87742b$var$_temp);
        T0 = (0, $gdv5Z.default);
        t3 = $c5ab38ff0f87742b$var$styles.wrapper;
        t4 = testId;
        t5 = iconUrls.length > 0 ? iconUrls.map((url, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                key: `${displayTypes[i]}-${i}`,
                xcss: i === 0 ? $c5ab38ff0f87742b$var$styles.iconSlotFirst : $c5ab38ff0f87742b$var$styles.iconSlot,
                style: {
                    zIndex: $c5ab38ff0f87742b$var$iconZIndex(i, iconUrls.length)
                },
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
                src: url,
                width: $c5ab38ff0f87742b$var$ICON_SIZE[variant],
                height: $c5ab38ff0f87742b$var$ICON_SIZE[variant],
                fallback: $c5ab38ff0f87742b$var$_temp2,
                role: "presentation"
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "currentColor"
        });
        $[0] = contentTypes;
        $[1] = testId;
        $[2] = variant;
        $[3] = T0;
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else {
        T0 = $[3];
        t3 = $[4];
        t4 = $[5];
        t5 = $[6];
    }
    let t6;
    if ($[7] !== T0 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            xcss: t3,
            testId: t4
        }, t5);
        $[7] = T0;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
};
function $c5ab38ff0f87742b$var$_temp(t) {
    return $c5ab38ff0f87742b$export$54e0f9305a4808e9(t);
}
function $c5ab38ff0f87742b$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}


const $b84c4cb49dedd5e2$var$i18n = (0, $cgtv4.defineMessages)({
    bringTogetherTitle: {
        id: "side-navigation.review-content-suggestions-modal.bring-together-title",
        defaultMessage: "Bring together the info that matters"
    },
    bringTogetherDescription: {
        id: "side-navigation.review-content-suggestions-modal.bring-together-description",
        defaultMessage: "Use these suggestions to organize everything in one space"
    },
    addItemsToSpace: {
        id: "side-navigation.review-content-suggestions-modal.add-items-to-space",
        defaultMessage: "Add {count, plural, one {# item} other {# items}} to space"
    },
    expandGroup: {
        id: "side-navigation.review-content-suggestions-modal.expand-group",
        defaultMessage: "Expand {title}"
    },
    collapseGroup: {
        id: "side-navigation.review-content-suggestions-modal.collapse-group",
        defaultMessage: "Collapse {title}"
    },
    openSuggestion: {
        id: "side-navigation.review-content-suggestions-modal.open-suggestion",
        defaultMessage: "Open {title} in a new tab"
    },
    deselectGroup: {
        id: "side-navigation.review-content-suggestions-modal.deselect-group",
        defaultMessage: "Deselect group {title}"
    },
    selectGroup: {
        id: "side-navigation.review-content-suggestions-modal.select-group",
        defaultMessage: "Select group {title}"
    },
    deselectItem: {
        id: "side-navigation.review-content-suggestions-modal.deselect-item",
        defaultMessage: "Deselect {title}"
    },
    selectItem: {
        id: "side-navigation.review-content-suggestions-modal.select-item",
        defaultMessage: "Select {title}"
    },
    untitled: {
        id: "side-navigation.review-content-suggestions-modal.untitled",
        defaultMessage: "Untitled"
    }
});
function $b84c4cb49dedd5e2$var$getSuggestionIconUrl(url) {
    for (const entry of (0, $090b31fb8b21ef86$export$51b10001420b4ba3)){
        if (url.includes(entry.pattern)) return entry.iconUrl;
    }
    return (0, $090b31fb8b21ef86$export$9911254b1f812303).iconUrl;
}
const $b84c4cb49dedd5e2$var$styles = {
    layout: "_4t3iufrr",
    leftPanel: "_zulp1ejb _16jlkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1bsb1ssb",
    groupListScrollArea: "_16jlkb7n _18m91wug _1fjgglyw _1tkeidpf",
    rightPanel: "_2rko1qi0 _16jlkb7n _i0dlf1ug _bfhk6vm6 _1bsb1ssb",
    groupCard: "_2rko1qi0 _1reo15vq _18m915vq _v5641po6 _189ee4h9 _1dqonqa1 _1h6d1l7x _bfhki8nm _4cvx1ihb",
    groupCardExpanded: "_1h6d1ihb",
    checkButton: "_1rjcutpp _1e0c1txw _4cvr1h6o _1bah1h6o _bozgutpp _y4tiu2gc _bfhk1j28 _1o9zidpf _irr31j28",
    expandButton: "_zulpu2gc _1rjcutpp _1e0c1txw _4cvr1h6o _1bah1y6m _y3gnv2br _16jlkb7n _bozg1b66 _y4tiutpp _bfhk1j28 _irr31j28",
    groupTitleWrapper: "_1reo15vq _18m915vq _16jlkb7n _1bto1l2s _o5721q9c",
    itemsListOuter: "_v5641i4b _1e0c11p5 _2z0563bf _tzy4idpf",
    itemsListOuterExpanded: "_2z05hkll _tzy4kb7n",
    itemsList: "_1reo15vq _18m915vq _1tkeidpf _uwhke4h9 _15a5nqa1 _1i531l7x",
    itemCheckButton: "_1rjcu2gc _1e0c1txw _4cvr1h6o _1bah1h6o _bozgutpp _y4tiu2gc _bfhk1j28 _1o9zidpf _irr31j28",
    suggestionLinkWrapper: "_16jlkb7n _1ul9idpf",
    suggestionLink: "_zulpu2gc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjc12x7 _1e0c1txw _4cvr1h6o _1n261q9c _1ul9idpf _y4tiutpp _syazi7uo _9oik1r31 _1bnxglyw _jf4cnqa1",
    suggestionIconSlot: "_1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf",
    suggestionTitleWrapper: "_1reo15vq _18m915vq _16jlkb7n _1ul9idpf _1bto1l2s _o5721q9c",
    suggestionLinkExternalIcon: "_1o9zidpf",
    addButtonRow: "_85i5pxbi",
    itemRow: "_irr3plhp"
};
const $b84c4cb49dedd5e2$var$SuggestionItemRow = (t0)=>{
    const $ = (0, $frIzR.c)(31);
    const { suggestion: suggestion, isSelected: isSelected, onToggleSelectItem: onToggleSelectItem } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== suggestion.url) {
        t1 = $b84c4cb49dedd5e2$var$getSuggestionIconUrl(suggestion.url);
        $[0] = suggestion.url;
        $[1] = t1;
    } else t1 = $[1];
    const iconUrl = t1;
    let t2;
    if ($[2] !== onToggleSelectItem || $[3] !== suggestion.id) {
        t2 = ()=>onToggleSelectItem(suggestion.id);
        $[2] = onToggleSelectItem;
        $[3] = suggestion.id;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = isSelected ? $b84c4cb49dedd5e2$var$i18n.deselectItem : $b84c4cb49dedd5e2$var$i18n.selectItem;
    let t4;
    if ($[5] !== formatMessage || $[6] !== suggestion.title || $[7] !== t3) {
        t4 = formatMessage(t3, {
            title: suggestion.title
        });
        $[5] = formatMessage;
        $[6] = suggestion.title;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== isSelected) {
        t5 = isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
            label: "",
            color: "var(--ds-icon, #292A2E)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fPK4h))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[9] = isSelected;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t2 || $[12] !== t4 || $[13] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.itemCheckButton,
            onClick: t2,
            "aria-label": t4
        }, t5);
        $[11] = t2;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    const t7 = suggestion.url;
    let t8;
    if ($[15] !== formatMessage || $[16] !== suggestion.title) {
        t8 = formatMessage($b84c4cb49dedd5e2$var$i18n.openSuggestion, {
            title: suggestion.title
        });
        $[15] = formatMessage;
        $[16] = suggestion.title;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== iconUrl) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionIconSlot,
            "aria-hidden": "true"
        }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: iconUrl,
            width: "16",
            height: "16",
            fallback: $b84c4cb49dedd5e2$var$_temp,
            role: "presentation"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[18] = iconUrl;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== suggestion.title) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionTitleWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, suggestion.title));
        $[20] = suggestion.title;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionLinkExternalIcon,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== suggestion.url || $[24] !== t10 || $[25] !== t8 || $[26] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionLinkWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
            href: t7,
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": t8,
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionLink
        }, t9, t10, t11));
        $[23] = suggestion.url;
        $[24] = t10;
        $[25] = t8;
        $[26] = t9;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== t12 || $[29] !== t6) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            xcss: $b84c4cb49dedd5e2$var$styles.itemRow
        }, t6, t12);
        $[28] = t12;
        $[29] = t6;
        $[30] = t13;
    } else t13 = $[30];
    return t13;
};
const $b84c4cb49dedd5e2$var$SuggestionGroupRow = (t0)=>{
    const $ = (0, $frIzR.c)(57);
    const { parentTitle: parentTitle, suggestions: suggestions, isExpanded: isExpanded, isGroupSelected: isGroupSelected, selectedItems: selectedItems, toggleExpand: toggleExpand, parentId: parentId, toggleSelectGroup: toggleSelectGroup, onToggleSelectItem: onToggleSelectItem } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const t1 = isExpanded && $b84c4cb49dedd5e2$var$styles.groupCardExpanded;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.groupCard, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== suggestions || $[3] !== toggleSelectGroup) {
        t3 = ()=>toggleSelectGroup(suggestions);
        $[2] = suggestions;
        $[3] = toggleSelectGroup;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = isGroupSelected ? $b84c4cb49dedd5e2$var$i18n.deselectGroup : $b84c4cb49dedd5e2$var$i18n.selectGroup;
    let t5;
    if ($[5] !== formatMessage || $[6] !== parentTitle || $[7] !== t4) {
        t5 = formatMessage(t4, {
            title: parentTitle
        });
        $[5] = formatMessage;
        $[6] = parentTitle;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== isGroupSelected) {
        t6 = isGroupSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
            label: "",
            color: "var(--ds-icon, #292A2E)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fPK4h))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[9] = isGroupSelected;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t3 || $[12] !== t5 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.checkButton,
            onClick: t3,
            "aria-label": t5
        }, t6);
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== parentId || $[16] !== toggleExpand) {
        t8 = ()=>toggleExpand(parentId);
        $[15] = parentId;
        $[16] = toggleExpand;
        $[17] = t8;
    } else t8 = $[17];
    const t9 = isExpanded ? $b84c4cb49dedd5e2$var$i18n.collapseGroup : $b84c4cb49dedd5e2$var$i18n.expandGroup;
    let t10;
    if ($[18] !== formatMessage || $[19] !== parentTitle || $[20] !== t9) {
        t10 = formatMessage(t9, {
            title: parentTitle
        });
        $[18] = formatMessage;
        $[19] = parentTitle;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== parentTitle) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.groupTitleWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, parentTitle));
        $[22] = parentTitle;
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== suggestions.length) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, suggestions.length);
        $[24] = suggestions.length;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== isExpanded) {
        t13 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[26] = isExpanded;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== isExpanded || $[29] !== t10 || $[30] !== t11 || $[31] !== t12 || $[32] !== t13 || $[33] !== t8) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.expandButton,
            onClick: t8,
            "aria-expanded": isExpanded,
            "aria-label": t10
        }, t11, t12, t13);
        $[28] = isExpanded;
        $[29] = t10;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
        $[33] = t8;
        $[34] = t14;
    } else t14 = $[34];
    let t15;
    if ($[35] !== t14 || $[36] !== t7) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), null, t7, t14);
        $[35] = t14;
        $[36] = t7;
        $[37] = t15;
    } else t15 = $[37];
    const t16 = isExpanded && $b84c4cb49dedd5e2$var$styles.itemsListOuterExpanded;
    let t17;
    if ($[38] !== t16) {
        t17 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.itemsListOuter, t16);
        $[38] = t16;
        $[39] = t17;
    } else t17 = $[39];
    const t18 = !isExpanded;
    let t19;
    if ($[40] !== onToggleSelectItem || $[41] !== selectedItems || $[42] !== suggestions) {
        let t20;
        if ($[44] !== onToggleSelectItem || $[45] !== selectedItems) {
            t20 = (suggestion)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$SuggestionItemRow, {
                    key: suggestion.id,
                    suggestion: suggestion,
                    isSelected: selectedItems.has(suggestion.id),
                    onToggleSelectItem: onToggleSelectItem
                });
            $[44] = onToggleSelectItem;
            $[45] = selectedItems;
            $[46] = t20;
        } else t20 = $[46];
        t19 = suggestions.map(t20);
        $[40] = onToggleSelectItem;
        $[41] = selectedItems;
        $[42] = suggestions;
        $[43] = t19;
    } else t19 = $[43];
    let t20;
    if ($[47] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.itemsList
        }, t19);
        $[47] = t19;
        $[48] = t20;
    } else t20 = $[48];
    let t21;
    if ($[49] !== t17 || $[50] !== t18 || $[51] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t17,
            "aria-hidden": t18
        }, t20);
        $[49] = t17;
        $[50] = t18;
        $[51] = t20;
        $[52] = t21;
    } else t21 = $[52];
    let t22;
    if ($[53] !== t15 || $[54] !== t2 || $[55] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t2
        }, t15, t21);
        $[53] = t15;
        $[54] = t2;
        $[55] = t21;
        $[56] = t22;
    } else t22 = $[56];
    return t22;
};
const $b84c4cb49dedd5e2$var$ModalLeftPanel = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { groupedSuggestionsWithTitles: groupedSuggestionsWithTitles, selectedItems: selectedItems, expandedGroups: expandedGroups, toggleExpand: toggleExpand, toggleSelectGroup: toggleSelectGroup, toggleSelectItem: toggleSelectItem } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== expandedGroups || $[1] !== formatMessage || $[2] !== groupedSuggestionsWithTitles || $[3] !== selectedItems || $[4] !== toggleExpand || $[5] !== toggleSelectGroup || $[6] !== toggleSelectItem) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, [
            ...groupedSuggestionsWithTitles.entries()
        ].map((t2)=>{
            const [parentId, t3] = t2;
            const { parentTitle: parentTitle, suggestions: groupSuggestions } = t3;
            const isGroupSelected = groupSuggestions.every((s)=>selectedItems.has(s.id));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$SuggestionGroupRow, {
                key: parentId,
                parentTitle: parentTitle || formatMessage($b84c4cb49dedd5e2$var$i18n.untitled),
                suggestions: groupSuggestions,
                isExpanded: expandedGroups.has(parentId),
                isGroupSelected: isGroupSelected,
                selectedItems: selectedItems,
                toggleExpand: toggleExpand,
                parentId: parentId,
                toggleSelectGroup: toggleSelectGroup,
                onToggleSelectItem: toggleSelectItem
            });
        }));
        $[0] = expandedGroups;
        $[1] = formatMessage;
        $[2] = groupedSuggestionsWithTitles;
        $[3] = selectedItems;
        $[4] = toggleExpand;
        $[5] = toggleSelectGroup;
        $[6] = toggleSelectItem;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
const $b84c4cb49dedd5e2$export$c9ce09b966ffa4f7 = (t0)=>{
    const $ = (0, $frIzR.c)(51);
    const { groups: groups, contentTypes: contentTypes, onClose: onClose, onSaveSuccess: onSaveSuccess } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== groups) {
        t1 = groups.flatMap($b84c4cb49dedd5e2$var$_temp2);
        $[0] = groups;
        $[1] = t1;
    } else t1 = $[1];
    const allSuggestions = t1;
    const [expandedGroups, setExpandedGroups] = (0, $42omo.useState)($b84c4cb49dedd5e2$var$_temp3);
    let t2;
    if ($[2] !== allSuggestions) {
        t2 = ()=>new Set(allSuggestions.map($b84c4cb49dedd5e2$var$_temp4));
        $[2] = allSuggestions;
        $[3] = t2;
    } else t2 = $[3];
    const [selectedItems, setSelectedItems] = (0, $42omo.useState)(t2);
    let t3;
    if ($[4] !== groups) {
        t3 = groups.map($b84c4cb49dedd5e2$var$_temp5);
        $[4] = groups;
        $[5] = t3;
    } else t3 = $[5];
    const parentIds = t3;
    const titlesByContentId = (0, $d765c8713688ab6e$export$7610585fadab893e)(parentIds);
    let result;
    if ($[6] !== groups || $[7] !== titlesByContentId) {
        result = new Map();
        groups.forEach((group)=>{
            result.set(group.parentId, {
                parentTitle: titlesByContentId.get(String(group.parentId)) ?? "",
                suggestions: group.remoteObjects
            });
        });
        $[6] = groups;
        $[7] = titlesByContentId;
        $[8] = result;
    } else result = $[8];
    const groupedSuggestionsWithTitles = result;
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (parentId)=>{
            setExpandedGroups((prev)=>{
                const next = new Set(prev);
                if (next.has(parentId)) next.delete(parentId);
                else next.add(parentId);
                return next;
            });
        };
        $[9] = t4;
    } else t4 = $[9];
    const toggleExpand = t4;
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (itemId)=>{
            setSelectedItems((prev_0)=>{
                const next_0 = new Set(prev_0);
                if (next_0.has(itemId)) next_0.delete(itemId);
                else next_0.add(itemId);
                return next_0;
            });
        };
        $[10] = t5;
    } else t5 = $[10];
    const toggleSelectItem = t5;
    let t6;
    if ($[11] !== selectedItems) {
        t6 = (groupSuggestions)=>{
            const allSelected = groupSuggestions.every((s_0)=>selectedItems.has(s_0.id));
            setSelectedItems((prev_1)=>{
                const next_1 = new Set(prev_1);
                groupSuggestions.forEach((s_1)=>{
                    if (allSelected) next_1.delete(s_1.id);
                    else next_1.add(s_1.id);
                });
                return next_1;
            });
        };
        $[11] = selectedItems;
        $[12] = t6;
    } else t6 = $[12];
    const toggleSelectGroup = t6;
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
            hasCloseButton: true
        });
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== contentTypes) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5ab38ff0f87742b$export$98526f0dffd4f41b), {
            contentTypes: contentTypes,
            variant: "large"
        });
        $[14] = contentTypes;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== formatMessage) {
        t9 = formatMessage($b84c4cb49dedd5e2$var$i18n.bringTogetherTitle);
        $[16] = formatMessage;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "medium"
        }, t9);
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== formatMessage) {
        t11 = formatMessage($b84c4cb49dedd5e2$var$i18n.bringTogetherDescription);
        $[20] = formatMessage;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, t11);
        $[22] = t11;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== t10 || $[25] !== t12 || $[26] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, t8, t10, t12);
        $[24] = t10;
        $[25] = t12;
        $[26] = t8;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== expandedGroups || $[29] !== groupedSuggestionsWithTitles || $[30] !== selectedItems || $[31] !== toggleSelectGroup) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.groupListScrollArea
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$ModalLeftPanel, {
            groupedSuggestionsWithTitles: groupedSuggestionsWithTitles,
            selectedItems: selectedItems,
            expandedGroups: expandedGroups,
            toggleExpand: toggleExpand,
            toggleSelectGroup: toggleSelectGroup,
            toggleSelectItem: toggleSelectItem
        }));
        $[28] = expandedGroups;
        $[29] = groupedSuggestionsWithTitles;
        $[30] = selectedItems;
        $[31] = toggleSelectGroup;
        $[32] = t14;
    } else t14 = $[32];
    const t15 = selectedItems.size === 0;
    let t16;
    if ($[33] !== formatMessage || $[34] !== selectedItems.size) {
        t16 = formatMessage($b84c4cb49dedd5e2$var$i18n.addItemsToSpace, {
            count: selectedItems.size
        });
        $[33] = formatMessage;
        $[34] = selectedItems.size;
        $[35] = t16;
    } else t16 = $[35];
    let t17;
    if ($[36] !== onSaveSuccess || $[37] !== t15 || $[38] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            justifyContent: "end",
            xcss: $b84c4cb49dedd5e2$var$styles.addButtonRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: onSaveSuccess,
            isDisabled: t15
        }, t16));
        $[36] = onSaveSuccess;
        $[37] = t15;
        $[38] = t16;
        $[39] = t17;
    } else t17 = $[39];
    let t18;
    if ($[40] !== t13 || $[41] !== t14 || $[42] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.leftPanel
        }, t13, t14, t17);
        $[40] = t13;
        $[41] = t14;
        $[42] = t17;
        $[43] = t18;
    } else t18 = $[43];
    let t19;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.rightPanel
        });
        $[44] = t19;
    } else t19 = $[44];
    let t20;
    if ($[45] !== t18) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.layout
        }, t18, t19));
        $[45] = t18;
        $[46] = t20;
    } else t20 = $[46];
    let t21;
    if ($[47] !== Modal || $[48] !== onClose || $[49] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            onClose: onClose,
            width: "x-large"
        }, t7, t20);
        $[47] = Modal;
        $[48] = onClose;
        $[49] = t20;
        $[50] = t21;
    } else t21 = $[50];
    return t21;
};
function $b84c4cb49dedd5e2$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}
function $b84c4cb49dedd5e2$var$_temp2(g) {
    return g.remoteObjects;
}
function $b84c4cb49dedd5e2$var$_temp3() {
    return new Set();
}
function $b84c4cb49dedd5e2$var$_temp4(s) {
    return s.id;
}
function $b84c4cb49dedd5e2$var$_temp5(g_0) {
    return String(g_0.parentId);
}






var $f7B1p = parcelRequire("f7B1p");

const $d3bfb9815ee47511$export$b1532bcf7c9b2548 = (spaceKey)=>{
    const [groups, setGroups] = (0, $42omo.useState)([]);
    (0, $42omo.useEffect)(()=>{
        if (!spaceKey) return;
        const fetchSuggestions = async ()=>{
            try {
                const response = await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions`, {
                    method: 'GET'
                });
                const data = await response.json();
                if (data.suggestions && data.suggestions.length > 0) setGroups(data.suggestions);
            } catch  {
            // Silently fail — card won't render if there are no suggestions
            }
        };
        fetchSuggestions();
    }, [
        spaceKey
    ]);
    return groups;
};




function $e69b9564388a8a7c$export$451fcc3902224a39(url) {
    for (const entry of (0, $090b31fb8b21ef86$export$51b10001420b4ba3)){
        if (url.includes(entry.pattern)) return {
            product: entry.product,
            iconUrl: entry.iconUrl
        };
    }
    return 0, $090b31fb8b21ef86$export$9911254b1f812303;
}
const $e69b9564388a8a7c$var$styles = {
    container: "_2rko1qi0 _1reo15vq _18m915vq _bfhki8nm _19pku2gc _irr3plhp",
    mainAction: "_zulpu2gc _1rjcu2gc _16jlkb7n _1e0c1txw _4cvr1h6o _bozgu2gc _bfhk1j28",
    iconsWrapper: "_1e0c1txw _4cvr1h6o _1o9zidpf",
    dismissButton: "_1yt41b66 _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1j28 _irr31j28"
};
const $e69b9564388a8a7c$var$i18n = (0, $cgtv4.defineMessages)({
    addContent: {
        id: "side-navigation.space-navigation.related-content.add-content",
        defaultMessage: "Add content from your apps"
    },
    dismiss: {
        id: "side-navigation.space-navigation.related-content.dismiss",
        defaultMessage: "Dismiss related content"
    }
});
const $e69b9564388a8a7c$export$8372b97ddec977cb = ()=>{
    const $ = (0, $frIzR.c)(30);
    const intl = (0, $8C5kA.default)();
    const [isVisible, setIsVisible] = (0, $42omo.useState)(true);
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isPersonalSpace = (0, $1I9Gw.isPersonalSpace)(spaceKey);
    const groups = (0, $d3bfb9815ee47511$export$b1532bcf7c9b2548)(spaceKey);
    let t0;
    if ($[0] !== groups) {
        t0 = Array.from(new Set(groups.flatMap($e69b9564388a8a7c$var$_temp).map($e69b9564388a8a7c$var$_temp2).filter($e69b9564388a8a7c$var$_temp3)));
        $[0] = groups;
        $[1] = t0;
    } else t0 = $[1];
    const contentTypes = t0;
    if (isPersonalSpace || !isVisible || groups.length === 0) return null;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsModalOpen(true);
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== contentTypes) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e69b9564388a8a7c$var$styles.iconsWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5ab38ff0f87742b$export$98526f0dffd4f41b), {
            contentTypes: contentTypes
        }));
        $[3] = contentTypes;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== intl) {
        t3 = intl.formatMessage($e69b9564388a8a7c$var$i18n.addContent);
        $[5] = intl;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, t3);
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t2 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $e69b9564388a8a7c$var$styles.mainAction,
            onClick: t1
        }, t2, t4);
        $[9] = t2;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>setIsVisible(false);
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== intl) {
        t7 = intl.formatMessage($e69b9564388a8a7c$var$i18n.dismiss);
        $[13] = intl;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: ""
        });
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $e69b9564388a8a7c$var$styles.dismissButton,
            onClick: t6,
            "aria-label": t7
        }, t8);
        $[16] = t7;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t5 || $[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e69b9564388a8a7c$var$styles.container,
            testId: "space-navigation-related-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center"
        }, t5, t9));
        $[18] = t5;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== contentTypes || $[22] !== groups || $[23] !== isModalOpen) {
        t11 = isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b84c4cb49dedd5e2$export$c9ce09b966ffa4f7), {
            groups: groups,
            contentTypes: contentTypes,
            onClose: ()=>setIsModalOpen(false),
            onSaveSuccess: ()=>setIsModalOpen(false)
        });
        $[21] = contentTypes;
        $[22] = groups;
        $[23] = isModalOpen;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t11);
        $[25] = t11;
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] !== t10 || $[28] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t12);
        $[27] = t10;
        $[28] = t12;
        $[29] = t13;
    } else t13 = $[29];
    return t13;
};
function $e69b9564388a8a7c$var$_temp(g) {
    return g.remoteObjects;
}
function $e69b9564388a8a7c$var$_temp2(s) {
    return $e69b9564388a8a7c$export$451fcc3902224a39(s.url).product;
}
function $e69b9564388a8a7c$var$_temp3(p) {
    return p && p !== "Link";
}



var $5s27v = parcelRequire("5s27v");
















var $1Zr9M = parcelRequire("1Zr9M");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");





var $3gadb = parcelRequire("3gadb");


var $jZM59 = parcelRequire("jZM59");


var $5izcQ = parcelRequire("5izcQ");


var $inPa6 = parcelRequire("inPa6");


var $9x2sR = parcelRequire("9x2sR");


var $bedQP = parcelRequire("bedQP");





var $hXDOc = parcelRequire("hXDOc");


var $1NBp8 = parcelRequire("1NBp8");


var $1ytiN = parcelRequire("1ytiN");


var $eWwvy = parcelRequire("eWwvy");


var $6lvbX = parcelRequire("6lvbX");


var $d1wmn = parcelRequire("d1wmn");


var $joey7 = parcelRequire("joey7");





var $dPJCf = parcelRequire("dPJCf");





var $1kHsc = parcelRequire("1kHsc");








var $jrref = parcelRequire("jrref");




var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");

var $aG6kF = parcelRequire("aG6kF");


var $gj7hi = parcelRequire("gj7hi");


var $fT2ta = parcelRequire("fT2ta");





var $3SChL = parcelRequire("3SChL");


var $3Awqk = parcelRequire("3Awqk");


var $2AgON = parcelRequire("2AgON");


var $35Nok = parcelRequire("35Nok");

var $5ecc3f8934f85e59$exports = {};
$5ecc3f8934f85e59$exports = new URL("Spaces.5611c4bd.gif", import.meta.url).toString();


var $db1162a25db39e60$exports = {};
$db1162a25db39e60$exports = new URL("Spaces-dark.4ceec6cd.gif", import.meta.url).toString();


var $537a412b2964f6f0$exports = {};
$537a412b2964f6f0$exports = new URL("Spaces-placeholder.5b3f2999.png", import.meta.url).toString();


var $a4e38a378b5824d3$exports = {};
$a4e38a378b5824d3$exports = new URL("Spaces-placeholder-dark.1c1d1b34.png", import.meta.url).toString();


const $f37e6d818dab503c$var$STEP_ID = 'nth-user-orientation-editor-space-spotlight';
const $f37e6d818dab503c$export$febddff29c5b0caa = ({ children: children })=>{
    const { reset: reset, next: next, currentStep: currentStep, progress: progress, hasInteracted: hasInteracted, active: active } = (0, $3SChL.useTour)($f37e6d818dab503c$var$STEP_ID);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isVisible = currentStep === $f37e6d818dab503c$var$STEP_ID;
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const currentSrc = (0, $35Nok.usePreloadGif)({
        gif: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($5ecc3f8934f85e59$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($db1162a25db39e60$exports)))
        },
        placeholder: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($537a412b2964f6f0$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($a4e38a378b5824d3$exports)))
        },
        skip: !active
    });
    const { handleNext: handleNext, handleDismiss: handleDismiss } = (0, $2AgON.useSpotlightAnalytics)({
        spotlightId: $f37e6d818dab503c$var$STEP_ID,
        isVisible: isVisible,
        onNext: next,
        onDismiss: reset
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrref.Hide), {
        below: "md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopoverContent, {
        shouldDismissOnClickOutside: false,
        dismiss: handleDismiss,
        next: handleNext,
        placement: "right-end",
        offset: [
            0,
            24
        ],
        isVisible: isVisible,
        messageId: $f37e6d818dab503c$var$STEP_ID,
        messageType: hasInteracted ? 'transactional' : 'engagement'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "left"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: $f37e6d818dab503c$var$STEP_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).headline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: currentSrc,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $3Awqk.spotlight).progress, progress)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage((0, $3Awqk.spotlight).next))))))))));
};











var $gtD4K = parcelRequire("gtD4K");


var $euUgw = parcelRequire("euUgw");







var $dcJ7R = parcelRequire("dcJ7R");









var $eGUIL = parcelRequire("eGUIL");

const $39cc7021b1f9471a$export$c915848be66d4457 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { showExCoMessaging: t1 } = t0;
    const showExCoMessaging = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { handleScrollToTop: handleScrollToTop } = (0, $eGUIL.useSideNavigation)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== handleScrollToTop) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "QuickAccess",
                    source: "spaceNavigation",
                    data: {
                        navigationLayer: "global",
                        navigationContainer: "sidebar",
                        navVersion: "4"
                    }
                }
            }).fire();
            handleScrollToTop();
        };
        $[0] = createAnalyticsEvent;
        $[1] = handleScrollToTop;
        $[2] = t2;
    } else t2 = $[2];
    const onClick = t2;
    const t3 = showExCoMessaging && $39cc7021b1f9471a$var$additionalOffset;
    let t4;
    if ($[3] !== t3) {
        t4 = [
            $39cc7021b1f9471a$var$pressableStyles,
            $39cc7021b1f9471a$var$stickyWrapper,
            t3
        ];
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            borderColor: "transparent"
        };
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        });
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050",
            alignInline: "center",
            alignBlock: "center"
        }, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            align: "center",
            size: "small",
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $39cc7021b1f9471a$var$i18n.scrollToTopButtonLabel)));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== onClick || $[9] !== t4) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: t4,
            id: "scroll-to-top-button",
            onClick: onClick,
            style: t5
        }, t7);
        $[8] = onClick;
        $[9] = t4;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $39cc7021b1f9471a$var$offsetElement
        });
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t8, t9);
        $[12] = t8;
        $[13] = t10;
    } else t10 = $[13];
    return t10;
};
const $39cc7021b1f9471a$var$offsetElement = (0, $ecnYn.xcss)({
    //this element keeps the spacing from he negative top margin tha hides the button
    height: '17px',
    width: `100%`,
    display: 'flex'
});
const $39cc7021b1f9471a$var$additionalOffset = (0, $ecnYn.xcss)({
    top: `76px`
});
const $39cc7021b1f9471a$var$stickyWrapper = (0, $ecnYn.xcss)({
    zIndex: 'card',
    // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
    display: 'flex',
    position: 'sticky',
    top: `62px`,
    // @ts-ignore not assignable to type 'MarginSpace | GlobalValue | undefined'
    marginTop: `-50px`,
    //this hides the button underneath the space header until the ser scrolls down
    marginLeft: `auto`,
    marginRight: 'auto'
});
const $39cc7021b1f9471a$var$pressableStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: 'radius.full',
    paddingInline: 'space.100',
    alignItems: 'center',
    justifyContent: 'center',
    width: '125px',
    height: '32px',
    flexShrink: '0',
    boxShadow: 'elevation.shadow.overlay',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.pressed'
    },
    ':focus': {
        outline: 'color.border.focused'
    }
});
const $39cc7021b1f9471a$var$i18n = (0, $cgtv4.defineMessages)({
    scrollToTopButtonLabel: {
        id: "side-navigation.global.scroll-to-top.button.label",
        defaultMessage: "Back to top"
    }
});














var $9VJDA = parcelRequire("9VJDA");


var $4kfV4 = parcelRequire("4kfV4");


var $1qfLF = parcelRequire("1qfLF");


var $lGgRw = parcelRequire("lGgRw");


var $cGtPE = parcelRequire("cGtPE");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");








var $fxBfz = parcelRequire("fxBfz");


var $fIcbd = parcelRequire("fIcbd");


var $4WZ5N = parcelRequire("4WZ5N");


var $gKvd9 = parcelRequire("gKvd9");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");





var $l4aBp = parcelRequire("l4aBp");


var $kPqqM = parcelRequire("kPqqM");





var $iquRY = parcelRequire("iquRY");

















var $cLo2u = parcelRequire("cLo2u");





var $euL71 = parcelRequire("euL71");

const $6cfd8df151da6401$export$f895d65616c5f77f = (props)=>{
    const $ = (0, $frIzR.c)(8);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const spaceKey = (0, $cLo2u.useSpaceKey)(props.spaceKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== edition || $[1] !== spaceKey) {
        t0 = (t1)=>{
            const { isSpaceAdmin: isSpaceAdmin } = t1;
            return isSpaceAdmin && edition === (0, $euL71.ConfluenceEdition).PREMIUM ? (0, $1NBp8.ADMIN_CENTER_SPACE).toUrl({
                spaceKey: spaceKey
            }) : (0, $1NBp8.SPACE_SETTINGS_DETAILS).toUrl({
                spaceKey: spaceKey
            });
        };
        $[0] = edition;
        $[1] = spaceKey;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== createAnalyticsEvent) {
        t1 = (t2)=>{
            const { analyticsSource: analyticsSource } = t2;
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "spaceSettingsLink",
                    source: analyticsSource
                }
            }).fire();
        };
        $[3] = createAnalyticsEvent;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            getHref: t0,
            fireClickedEvent: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
















var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $lebfc = parcelRequire("lebfc");





var $2MNkP = parcelRequire("2MNkP");


var $cyLm6 = parcelRequire("cyLm6");







var $5nBzc = parcelRequire("5nBzc");


var $u9agA = parcelRequire("u9agA");


var $1o4fX = parcelRequire("1o4fX");








var $3P1RK = parcelRequire("3P1RK");


var $8H5XZ = parcelRequire("8H5XZ");


var $7Sm4c = parcelRequire("7Sm4c");







const $b9015bac1c4347b8$export$ea453946378ceccc = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { isSpaceAdmin: isSpaceAdmin, canManageSomeUsers: canManageSomeUsers, edition: edition, spaceKey: spaceKey, onMenuItemClicked: onMenuItemClicked } = t0;
    const intl = (0, $8C5kA.default)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const showSpaceTools = isSpaceAdmin && edition === (0, $d9tcB.ConfluenceEdition).PREMIUM;
    const showUsers = canManageSomeUsers && edition !== (0, $d9tcB.ConfluenceEdition).FREE;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query SpaceMoreActionsMenuSpaceToolsQuery{license{trialEndDate}}`;
        $[0] = t1;
    } else t1 = $[0];
    const t2 = !showSpaceTools;
    let t3;
    if ($[1] !== t2) {
        t3 = {
            skip: t2
        };
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const { data: trialData, error: trialDetailsError } = (0, $j1Ss3.useQuery)(t1, t3);
    if ((0, $8H5XZ.isGraphQLError)(trialDetailsError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(trialDetailsError)) (0, $7Sm4c.markErrorAsHandled)(trialDetailsError);
    let t4;
    if ($[3] !== trialData?.license?.trialEndDate) {
        t4 = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(trialData?.license?.trialEndDate) ?? 0;
        $[3] = trialData?.license?.trialEndDate;
        $[4] = t4;
    } else t4 = $[4];
    const isPremiumTrial = t4 > 0;
    let t5;
    if ($[5] !== intl || $[6] !== isPremiumTrial || $[7] !== isRbacEnabled || $[8] !== onMenuItemClicked || $[9] !== showSpaceTools || $[10] !== showUsers || $[11] !== spaceKey) {
        t5 = showUsers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
            title: intl.formatMessage($b9015bac1c4347b8$var$i18n.spaceTools),
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: isRbacEnabled ? (0, $1NBp8.SPACE_MEMBERS).toUrl({
                spaceKey: spaceKey
            }) : (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
                spaceKey: spaceKey,
                tab: (0, $3P1RK.SpacePermissionsTabKey).Users
            }),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lebfc))), {
                label: "",
                color: "currentColor"
            }),
            onClick: onMenuItemClicked("spaceAddUsers"),
            UNSAFE_shouldDisableRouterLink: true,
            "data-testid": "space-add-users-link"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b9015bac1c4347b8$var$i18n.addUsers)), showSpaceTools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: (0, $1NBp8.SPACE_SETTINGS_AUTOMATION).toUrl({
                spaceKey: spaceKey
            }),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
                label: "",
                color: "currentColor"
            }),
            onClick: onMenuItemClicked("spaceAutomation"),
            UNSAFE_shouldDisableRouterLink: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.150",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b9015bac1c4347b8$var$i18n.automation), isPremiumTrial && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "new"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b9015bac1c4347b8$var$i18n.premiumLozenge)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: (0, $1NBp8.SPACE_BULK_TOOLS).toUrl({
                spaceKey: spaceKey
            }),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MNkP))), {
                label: "",
                color: "currentColor"
            }),
            onClick: onMenuItemClicked("spaceContentManager"),
            UNSAFE_shouldDisableRouterLink: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.150",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b9015bac1c4347b8$var$i18n.contentManager), isPremiumTrial && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "new"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b9015bac1c4347b8$var$i18n.premiumLozenge)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: (0, $1NBp8.SPACE_ANALYTICS).toUrl({
                spaceKey: spaceKey
            }),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))), {
                label: "",
                color: "currentColor"
            }),
            onClick: onMenuItemClicked("spaceAnalytics"),
            UNSAFE_shouldDisableRouterLink: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.150",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b9015bac1c4347b8$var$i18n.analytics), isPremiumTrial && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "new"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b9015bac1c4347b8$var$i18n.premiumLozenge))))));
        $[5] = intl;
        $[6] = isPremiumTrial;
        $[7] = isRbacEnabled;
        $[8] = onMenuItemClicked;
        $[9] = showSpaceTools;
        $[10] = showUsers;
        $[11] = spaceKey;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $b9015bac1c4347b8$var$i18n = (0, $cgtv4.defineMessages)({
    spaceTools: {
        id: "side-navigation.space-navigation.space-tools",
        defaultMessage: "Space tools"
    },
    addUsers: {
        id: "side-navigation.space-navigation.users",
        defaultMessage: "Users"
    },
    automation: {
        id: "side-navigation.space-navigation.automation",
        defaultMessage: "Automation"
    },
    contentManager: {
        id: "side-navigation.space-navigation.content-manager",
        defaultMessage: "Content manager"
    },
    analytics: {
        id: "side-navigation.space-navigation.analytics",
        defaultMessage: "Analytics"
    },
    premiumLozenge: {
        id: "side-navigation.space-navigation.premium-lozenge",
        defaultMessage: "Premium"
    }
});


const $476e0e4b3e7f33df$export$cd488ab2b367186 = (props)=>{
    const $ = (0, $frIzR.c)(20);
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (!isNav4Enabled) return null;
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== props) {
        t0 = ()=>{
            props.setIsOpen(!props.isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "spaceMoreActionsMenu",
                    source: "spaceNavigation",
                    attributes: {
                        navigationLayer: "container",
                        navigationContainer: "sidebar",
                        navVersion: "4",
                        componentType: "fixedItemButton",
                        itemId: "meatballDropdown",
                        isSpaceAdmin: props.isSpaceAdmin
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    const onClick = t0;
    let t1;
    if ($[3] !== createAnalyticsEvent || $[4] !== props) {
        t1 = (selection)=>(e)=>{
                e.stopPropagation();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "spaceMoreActionsMenuItem",
                        source: "spaceMoreActionsMenu",
                        attributes: {
                            navigationLayer: "container",
                            navigationContainer: "sidebar",
                            navVersion: "4",
                            componentType: "fixedItemAction",
                            itemId: selection,
                            isSpaceAdmin: props.isSpaceAdmin
                        }
                    }
                }).fire();
                props.setIsOpen(false);
            };
        $[3] = createAnalyticsEvent;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const onMenuItemClicked = t1;
    let t2;
    if ($[6] !== props) {
        t2 = ()=>props.setIsOpen(false);
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== isLoggedIn || $[9] !== onMenuItemClicked || $[10] !== props) {
        t3 = ()=>isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($476e0e4b3e7f33df$var$SpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($476e0e4b3e7f33df$var$RestrictedSpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            });
        $[8] = isLoggedIn;
        $[9] = onMenuItemClicked;
        $[10] = props;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== onClick || $[13] !== props) {
        t4 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                icon: $476e0e4b3e7f33df$var$_temp,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $476e0e4b3e7f33df$var$i18n.moreActions),
                onClick: onClick,
                spacing: "compact",
                appearance: "subtle",
                isSelected: props.isOpen
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                testId: "space-more-actions-menu-blanket",
                isTinted: false,
                shouldAllowClickThrough: !props.isOpen,
                onBlanketClicked: ()=>props.setIsOpen(false)
            }));
        $[12] = onClick;
        $[13] = props;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== props.isOpen || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: props.isOpen,
            onClose: t2,
            content: t3,
            trigger: t4,
            placement: "right-start"
        });
        $[15] = props.isOpen;
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    return t5;
};
const $476e0e4b3e7f33df$var$RestrictedSpaceMoreActionsMenuContent = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { spaceKey: spaceKey, isSpaceAdmin: isSpaceAdmin, onMenuItemClicked: onMenuItemClicked } = t0;
    let t1;
    if ($[0] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t1;
    } else t1 = $[1];
    const { getHref: getHref, fireClickedEvent: fireClickedEvent } = (0, $6cfd8df151da6401$export$f895d65616c5f77f)(t1);
    let t2;
    if ($[2] !== getHref || $[3] !== isSpaceAdmin) {
        t2 = getHref({
            isSpaceAdmin: isSpaceAdmin
        });
        $[2] = getHref;
        $[3] = isSpaceAdmin;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))), {
            label: "",
            color: "currentColor"
        });
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== fireClickedEvent || $[7] !== onMenuItemClicked) {
        t4 = (e)=>{
            fireClickedEvent({
                analyticsSource: "spaceMoreActionsMenu"
            });
            onMenuItemClicked("spaceSettings")(e);
        };
        $[6] = fireClickedEvent;
        $[7] = onMenuItemClicked;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $476e0e4b3e7f33df$var$i18n.spaceSettings);
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t2 || $[11] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
            minWidth: "240px"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: t2,
            iconBefore: t3,
            onClick: t4,
            UNSAFE_shouldDisableRouterLink: true
        }, t5)));
        $[10] = t2;
        $[11] = t4;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
};
const $476e0e4b3e7f33df$var$SpaceMoreActionsMenuContent = (t0)=>{
    const $ = (0, $frIzR.c)(48);
    const { spaceId: spaceId, spaceKey: spaceKey, isStarred: isStarred, isWatched: isWatched, isSpaceAdmin: isSpaceAdmin, canManageSomeUsers: canManageSomeUsers, isSpaceArchived: isSpaceArchived, onMenuItemClicked: onMenuItemClicked, hasDeleteSpacePermission: hasDeleteSpacePermission, hasArchiveSpacePermission: t1 } = t0;
    const hasArchiveSpacePermission = t1 === undefined ? false : t1;
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    let t2;
    if ($[0] !== spaceKey) {
        t2 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t2;
    } else t2 = $[1];
    const { getHref: getHref, fireClickedEvent: fireClickedEvent } = (0, $6cfd8df151da6401$export$f895d65616c5f77f)(t2);
    const shouldShowTrashSpaceButton = (0, $9wGTI.fg)("dlp-dlm-data-retention-policy") ? hasDeleteSpacePermission : true;
    const showArchiveSection = isRbacEnabled && (0, $6mKj3.expVal)("permissions_rbac_dependencies_callsites", "isEnabled", false) ? hasArchiveSpacePermission : isSpaceAdmin;
    let t3;
    if ($[2] !== isStarred || $[3] !== spaceId || $[4] !== spaceKey) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kPqqM.SpaceStarMenuItem), {
            spaceId: spaceId,
            spaceKey: spaceKey,
            isStarred: isStarred,
            spacing: "none"
        });
        $[2] = isStarred;
        $[3] = spaceId;
        $[4] = spaceKey;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== isWatched || $[7] !== spaceId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l4aBp.SpaceWatchButton), {
            spaceId: spaceId,
            isWatched: isWatched,
            inMenu: true
        });
        $[6] = isWatched;
        $[7] = spaceId;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), null, t3, t4);
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== canManageSomeUsers || $[13] !== edition || $[14] !== isSpaceAdmin || $[15] !== onMenuItemClicked || $[16] !== spaceKey) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9015bac1c4347b8$export$ea453946378ceccc), {
            canManageSomeUsers: canManageSomeUsers,
            isSpaceAdmin: isSpaceAdmin,
            edition: edition,
            spaceKey: spaceKey,
            onMenuItemClicked: onMenuItemClicked
        });
        $[12] = canManageSomeUsers;
        $[13] = edition;
        $[14] = isSpaceAdmin;
        $[15] = onMenuItemClicked;
        $[16] = spaceKey;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== edition || $[19] !== isSpaceAdmin || $[20] !== onMenuItemClicked || $[21] !== spaceKey) {
        t7 = isSpaceAdmin && edition !== (0, $d9tcB.ConfluenceEdition).PREMIUM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: (0, $1NBp8.SPACE_SETTINGS_AUTOMATION).toUrl({
                spaceKey: spaceKey
            }),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
                label: "",
                color: "currentColor"
            }),
            onClick: onMenuItemClicked("spaceAutomation"),
            UNSAFE_shouldDisableRouterLink: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $476e0e4b3e7f33df$var$i18n.automation));
        $[18] = edition;
        $[19] = isSpaceAdmin;
        $[20] = onMenuItemClicked;
        $[21] = spaceKey;
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== getHref || $[24] !== isSpaceAdmin) {
        t8 = getHref({
            isSpaceAdmin: isSpaceAdmin
        });
        $[23] = getHref;
        $[24] = isSpaceAdmin;
        $[25] = t8;
    } else t8 = $[25];
    let t9;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))), {
            label: "",
            color: "currentColor"
        });
        $[26] = t9;
    } else t9 = $[26];
    let t10;
    if ($[27] !== fireClickedEvent || $[28] !== onMenuItemClicked) {
        t10 = (e)=>{
            fireClickedEvent({
                analyticsSource: "spaceMoreActionsMenu"
            });
            onMenuItemClicked("spaceSettings")(e);
        };
        $[27] = fireClickedEvent;
        $[28] = onMenuItemClicked;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $476e0e4b3e7f33df$var$i18n.spaceSettings);
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== t10 || $[32] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: t8,
            iconBefore: t9,
            onClick: t10,
            UNSAFE_shouldDisableRouterLink: true
        }, t11);
        $[31] = t10;
        $[32] = t8;
        $[33] = t12;
    } else t12 = $[33];
    let t13;
    if ($[34] !== t12 || $[35] !== t7) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
            hasSeparator: true
        }, t7, t12);
        $[34] = t12;
        $[35] = t7;
        $[36] = t13;
    } else t13 = $[36];
    let t14;
    if ($[37] !== isSpaceArchived || $[38] !== onMenuItemClicked || $[39] !== shouldShowTrashSpaceButton || $[40] !== showArchiveSection || $[41] !== spaceKey) {
        t14 = showArchiveSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: (0, $1NBp8.SPACE_SETTINGS_ARCHIVE_SPACE).toUrl({
                spaceKey: spaceKey
            }),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4WZ5N))), {
                label: "",
                color: "currentColor"
            }),
            onClick: onMenuItemClicked("spaceArchive"),
            UNSAFE_shouldDisableRouterLink: true
        }, isSpaceArchived ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $476e0e4b3e7f33df$var$i18n.restoreSpace) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $476e0e4b3e7f33df$var$i18n.archiveSpace)), shouldShowTrashSpaceButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: (0, $1NBp8.SPACE_SETTINGS_TRASH_SPACE).toUrl({
                spaceKey: spaceKey
            }),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                label: "",
                color: "var(--ds-text-danger, #AE2E24)"
            }),
            onClick: onMenuItemClicked("spaceDelete"),
            UNSAFE_shouldDisableRouterLink: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.danger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $476e0e4b3e7f33df$var$i18n.trashSpace))));
        $[37] = isSpaceArchived;
        $[38] = onMenuItemClicked;
        $[39] = shouldShowTrashSpaceButton;
        $[40] = showArchiveSection;
        $[41] = spaceKey;
        $[42] = t14;
    } else t14 = $[42];
    let t15;
    if ($[43] !== t13 || $[44] !== t14 || $[45] !== t5 || $[46] !== t6) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
            minWidth: "240px"
        }, t5, t6, t13, t14);
        $[43] = t13;
        $[44] = t14;
        $[45] = t5;
        $[46] = t6;
        $[47] = t15;
    } else t15 = $[47];
    return t15;
};
const $476e0e4b3e7f33df$var$i18n = (0, $cgtv4.defineMessages)({
    moreActions: {
        id: "side-navigation.space-navigation.more-actions",
        defaultMessage: "More actions"
    },
    addUsers: {
        id: "side-navigation.space-navigation.users",
        defaultMessage: "Users"
    },
    automation: {
        id: "side-navigation.space-navigation.automation",
        defaultMessage: "Automation"
    },
    spaceSettings: {
        id: "side-navigation.space-navigation.space-settings",
        defaultMessage: "Space settings"
    },
    archiveSpace: {
        id: "side-navigation.space-navigation.archive-space",
        defaultMessage: "Archive space"
    },
    restoreSpace: {
        id: "side-navigation.space-navigation.restore-space",
        defaultMessage: "Restore space"
    },
    trashSpace: {
        id: "side-navigation.space-navigation.trash-space",
        defaultMessage: "Delete space"
    }
});
function $476e0e4b3e7f33df$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        ...iconProps,
        size: "small"
    });
}


const $6f43a2e4204022e9$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));
const $6f43a2e4204022e9$export$533fb76256978163 = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    let containsExternalCollaborators;
    let isExternalCollaborator;
    let props;
    if ($[0] !== t0) {
        ({ isExternalCollaborator: isExternalCollaborator, containsExternalCollaborators: containsExternalCollaborators, ...props } = t0);
        $[0] = t0;
        $[1] = containsExternalCollaborators;
        $[2] = isExternalCollaborator;
        $[3] = props;
    } else {
        containsExternalCollaborators = $[1];
        isExternalCollaborator = $[2];
        props = $[3];
    }
    const [showExCoOnboardingNudge, setShowExCoOnboardingNudge] = (0, $42omo.useState)(false);
    const [onboardingStep, setOnboardingStep] = (0, $42omo.useState)(0);
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = (0, $jZM59.usePageLayoutResize)();
    const { isNewUser: isNewUser } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const showExCoMessaging = !isExternalCollaborator && containsExternalCollaborators;
    const showExCoModalOnboarding = !isNewUser && showExCoMessaging;
    const showExCoSpotlightOnboarding = !isNewUser && showExCoMessaging && showExCoOnboardingNudge && !isLeftSidebarCollapsed;
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setShowExCoOnboardingNudge(true);
            setOnboardingStep(1);
        };
        $[4] = t1;
    } else t1 = $[4];
    const onGuestListOnboardingModalShown = t1;
    let t2;
    if ($[5] !== props || $[6] !== showExCoMessaging) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$SpaceHeaderInner, {
            ...props,
            showExCoMessaging: showExCoMessaging
        });
        $[5] = props;
        $[6] = showExCoMessaging;
        $[7] = t2;
    } else t2 = $[7];
    const header = t2;
    let t3;
    if ($[8] !== header || $[9] !== onboardingStep || $[10] !== showExCoSpotlightOnboarding) {
        t3 = showExCoSpotlightOnboarding && onboardingStep === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$SpaceHeaderExCoOnboarding, {
            header: header,
            onClose: ()=>setShowExCoOnboardingNudge(false)
        }) : header;
        $[8] = header;
        $[9] = onboardingStep;
        $[10] = showExCoSpotlightOnboarding;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== onboardingStep || $[13] !== props || $[14] !== showExCoModalOnboarding) {
        t4 = showExCoModalOnboarding && onboardingStep === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d1wmn.ExternalCollaboratorInSpaceNotify), {
            onModalClose: onGuestListOnboardingModalShown,
            spaceKey: props.spaceKey
        });
        $[12] = onboardingStep;
        $[13] = props;
        $[14] = showExCoModalOnboarding;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $joey7.GuestOnboardingModalLoadable), null);
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== t3 || $[18] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t3, t4, t5);
        $[17] = t3;
        $[18] = t4;
        $[19] = t6;
    } else t6 = $[19];
    return t6;
};
const $6f43a2e4204022e9$var$SpaceHeaderInner = (t0)=>{
    const $ = (0, $frIzR.c)(43);
    const { spaceId: spaceId, spaceName: spaceName, spaceKey: spaceKey, homepageId: homepageId, iconPath: iconPath, isStarred: isStarred, isWatched: isWatched, isSpaceAdmin: isSpaceAdmin, canManageSomeUsers: canManageSomeUsers, isPersonalSpace: isPersonalSpace, showExCoMessaging: showExCoMessaging, isSpaceArchived: isSpaceArchived, hasDeleteSpacePermission: hasDeleteSpacePermission, hasArchiveSpacePermission: hasArchiveSpacePermission } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isSelected = (0, $dPJCf.useRouteName)($6f43a2e4204022e9$var$isOnSpaceRouteArgs);
    let t1;
    if ($[0] !== homepageId || $[1] !== spaceKey) {
        t1 = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        }, homepageId ? {
            query: {
                [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: homepageId
            }
        } : undefined);
        $[0] = homepageId;
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const spaceOverviewHref = t1;
    let t2;
    if ($[3] !== showExCoMessaging || $[4] !== spaceKey) {
        t2 = showExCoMessaging ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            weight: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6lvbX.ExternalCollaboratorsSpaceInformationMessage), {
            analyticsSource: "spaceHeader",
            messageType: (0, $6lvbX.ExternalCollaboratorsSpaceInformationMessageType).IN_SPACE,
            shouldShowMessageIcon: false,
            shouldShowAdditionalMessageContext: false,
            spaceKey: spaceKey,
            isSubtle: true
        })) : undefined;
        $[3] = showExCoMessaging;
        $[4] = spaceKey;
        $[5] = t2;
    } else t2 = $[5];
    const description = t2;
    let t3;
    if ($[6] !== createAnalyticsEvent) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "spaceHeader",
                    source: "sideNavigation",
                    attributes: {
                        navVersion: 4
                    }
                }
            }).fire();
        };
        $[6] = createAnalyticsEvent;
        $[7] = t3;
    } else t3 = $[7];
    const onClick = t3;
    const [isMoreActionsOpen, setIsMoreActionsOpen] = (0, $42omo.useState)(false);
    let t4;
    if ($[8] !== canManageSomeUsers || $[9] !== hasArchiveSpacePermission || $[10] !== hasDeleteSpacePermission || $[11] !== isMoreActionsOpen || $[12] !== isSpaceAdmin || $[13] !== isSpaceArchived || $[14] !== isStarred || $[15] !== isWatched || $[16] !== spaceId || $[17] !== spaceKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $476e0e4b3e7f33df$export$cd488ab2b367186), {
            isOpen: isMoreActionsOpen,
            setIsOpen: setIsMoreActionsOpen,
            spaceId: spaceId,
            spaceKey: spaceKey,
            isStarred: isStarred,
            isWatched: isWatched,
            isSpaceAdmin: isSpaceAdmin,
            canManageSomeUsers: canManageSomeUsers,
            isSpaceArchived: isSpaceArchived,
            hasDeleteSpacePermission: hasDeleteSpacePermission,
            hasArchiveSpacePermission: hasArchiveSpacePermission
        });
        $[8] = canManageSomeUsers;
        $[9] = hasArchiveSpacePermission;
        $[10] = hasDeleteSpacePermission;
        $[11] = isMoreActionsOpen;
        $[12] = isSpaceAdmin;
        $[13] = isSpaceArchived;
        $[14] = isStarred;
        $[15] = isWatched;
        $[16] = spaceId;
        $[17] = spaceKey;
        $[18] = t4;
    } else t4 = $[18];
    const moreActionsMenu = t4;
    let t5;
    if ($[19] !== iconPath || $[20] !== isPersonalSpace || $[21] !== isSpaceAdmin || $[22] !== spaceKey) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$EditableSpaceIcon, {
            spaceKey: spaceKey,
            iconPath: iconPath,
            isSpaceAdmin: isSpaceAdmin,
            isPersonalSpace: isPersonalSpace
        });
        $[19] = iconPath;
        $[20] = isPersonalSpace;
        $[21] = isSpaceAdmin;
        $[22] = spaceKey;
        $[23] = t5;
    } else t5 = $[23];
    let t6;
    if ($[24] !== description || $[25] !== isSelected || $[26] !== moreActionsMenu || $[27] !== onClick || $[28] !== spaceName || $[29] !== spaceOverviewHref || $[30] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: spaceOverviewHref,
            isSelected: isSelected,
            onClick: onClick,
            elemBefore: t5,
            actions: moreActionsMenu,
            description: description
        }, spaceName);
        $[24] = description;
        $[25] = isSelected;
        $[26] = moreActionsMenu;
        $[27] = onClick;
        $[28] = spaceName;
        $[29] = spaceOverviewHref;
        $[30] = t5;
        $[31] = t6;
    } else t6 = $[31];
    let t7;
    if ($[32] !== spaceOverviewHref || $[33] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6f43a2e4204022e9$var$stickyWrapper,
            "data-vc": "Nav4-space-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$SpaceHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f37e6d818dab503c$export$febddff29c5b0caa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$RemovedSpotlightTarget, {
            name: "nav4-spotlight-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
            name: "space-header",
            preloadUrl: spaceOverviewHref,
            preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData
        }, t6)))));
        $[32] = spaceOverviewHref;
        $[33] = t6;
        $[34] = t7;
    } else t7 = $[34];
    let t8;
    if ($[35] !== showExCoMessaging) {
        t8 = !(0, $9wGTI.fg)("platform_dst_nav4_fhs_feedback_1") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            id: "space-header-bottom-divider",
            "data-vc": "space-header-bottom-divider-nav4",
            className: (0, $gMc0m.default)([
                "_195gxmi2 _n7zlia51 _kqsw1if8 _154i4bvh _1pbykb7n",
                showExCoMessaging && "_154it9kd"
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": "space-header-bottom-divider-cloak-nav4",
            className: (0, $gMc0m.default)([
                "_n7zlc4nj _kqswstnw _1bsbq7sw _154i4bvh _1ltvxmi2 _1pbycs5v",
                showExCoMessaging && "_154it9kd"
            ])
        }));
        $[35] = showExCoMessaging;
        $[36] = t8;
    } else t8 = $[36];
    let t9;
    if ($[37] !== showExCoMessaging) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39cc7021b1f9471a$export$c915848be66d4457), {
            showExCoMessaging: showExCoMessaging
        });
        $[37] = showExCoMessaging;
        $[38] = t9;
    } else t9 = $[38];
    let t10;
    if ($[39] !== t7 || $[40] !== t8 || $[41] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t7, t8, t9);
        $[39] = t7;
        $[40] = t8;
        $[41] = t9;
        $[42] = t10;
    } else t10 = $[42];
    return t10;
};
const $6f43a2e4204022e9$var$EditableSpaceIcon = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { spaceKey: spaceKey, iconPath: iconPath, isSpaceAdmin: isSpaceAdmin, isPersonalSpace: isPersonalSpace } = t0;
    const intl = (0, $8C5kA.default)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { leftSidebarState: leftSidebarState, expandLeftSidebar: expandLeftSidebar } = (0, $jZM59.usePageLayoutResize)();
    const [isDialogOpen, setIsDialogOpen] = (0, $42omo.useState)(false);
    const [shouldRenderDialog, setShouldRenderDialog] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== iconPath) {
        t1 = iconPath ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: iconPath,
            alt: "",
            "data-testid": "space-icon",
            "data-vc": "space-header-icon-image",
            "data-ssr-placeholder-ignored": true,
            role: "presentation",
            className: (0, $gMc0m.default)([
                "_2rko1qi0 _1bsb1tcg _4t3i1tcg"
            ])
        }) : null;
        $[0] = iconPath;
        $[1] = t1;
    } else t1 = $[1];
    const image = t1;
    const canEdit = isSpaceAdmin && !isPersonalSpace;
    if (!canEdit) return image;
    let t2;
    if ($[2] !== intl) {
        t2 = intl.formatMessage($6f43a2e4204022e9$var$i18n.editSpaceDetails);
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    const editLabel = t2;
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== expandLeftSidebar || $[6] !== experienceTracker || $[7] !== leftSidebarState.isFlyoutOpen) {
        t3 = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            experienceTracker.start({
                name: (0, $irVI7.EDIT_SPACE_LOGO_DETAILS_LOAD_EXPERIENCE),
                timeout: 10000
            });
            setShouldRenderDialog(true);
            setIsDialogOpen(true);
            if (leftSidebarState.isFlyoutOpen) expandLeftSidebar();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "editSpaceDetails",
                    source: "sideNavSpaceHeader",
                    attributes: {
                        navVersion: 4
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = expandLeftSidebar;
        $[6] = experienceTracker;
        $[7] = leftSidebarState.isFlyoutOpen;
        $[8] = t3;
    } else t3 = $[8];
    const onClick = t3;
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setShouldRenderDialog(true);
        };
        $[9] = t4;
    } else t4 = $[9];
    const onFocus = t4;
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setShouldRenderDialog(true);
        };
        $[10] = t5;
    } else t5 = $[10];
    const onMouseEnter = t5;
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsDialogOpen(true);
        };
        $[11] = t6;
    } else t6 = $[11];
    const onDialogOpen = t6;
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setIsDialogOpen(false);
        };
        $[12] = t7;
    } else t7 = $[12];
    const onDialogClose = t7;
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6f43a2e4204022e9$var$editIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }));
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== editLabel || $[15] !== image || $[16] !== onClick) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? $6f43a2e4204022e9$var$iconButton : $6f43a2e4204022e9$var$iconButtonFallback,
            "aria-label": editLabel,
            onClick: onClick,
            onFocus: onFocus,
            onMouseEnter: onMouseEnter
        }, image, t8);
        $[14] = editLabel;
        $[15] = image;
        $[16] = onClick;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== editLabel || $[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: editLabel
        }, t9);
        $[18] = editLabel;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== isDialogOpen || $[22] !== shouldRenderDialog || $[23] !== spaceKey) {
        t11 = shouldRenderDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey,
            isOpen: isDialogOpen,
            onOpen: onDialogOpen,
            onClose: onDialogClose
        });
        $[21] = isDialogOpen;
        $[22] = shouldRenderDialog;
        $[23] = spaceKey;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t10 || $[26] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t11);
        $[25] = t10;
        $[26] = t11;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
};
const $6f43a2e4204022e9$var$isOnSpaceRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_INDEX).name || routeName === (0, $1NBp8.SPACE_OVERVIEW).name
};
const $6f43a2e4204022e9$var$additionalOffset = null;
const $6f43a2e4204022e9$var$stickyBorderCoverNav4 = null;
const $6f43a2e4204022e9$var$stickyWrapper = (0, $ecnYn.xcss)({
    position: 'sticky',
    top: 'space.0',
    zIndex: 'navigation' // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
});
const $6f43a2e4204022e9$var$icon = null;
const $6f43a2e4204022e9$var$iconButton = (0, $ecnYn.xcss)({
    border: "var(--ds-space-0, 0px)",
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$iconButtonFallback = (0, $ecnYn.xcss)({
    border: 'none',
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$editIconWrapper = (0, $ecnYn.xcss)({
    position: 'absolute',
    height: '24px',
    width: '24px',
    top: 'space.0',
    left: 'space.0',
    padding: 'space.050',
    opacity: 0,
    transition: 'opacity 0.5s ease',
    ':hover': {
        opacity: 1
    },
    ':focus': {
        opacity: 1
    },
    backgroundColor: 'color.blanket',
    borderRadius: 'radius.medium'
});
const $6f43a2e4204022e9$var$stickyBorder = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f43a2e4204022e9$var$SpaceHeaderContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0qutpp _n3td1skh _bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});

const $6f43a2e4204022e9$var$SpaceHeaderExCoOnboarding = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "QrIC5",
    name: "SpaceHeaderExCoOnboarding",
    loader: async ()=>(await (parcelRequire("jAO76"))).SpaceHeaderExCoOnboarding
});
const $6f43a2e4204022e9$var$i18n = (0, $cgtv4.defineMessages)({
    editSpaceDetails: {
        id: "side-navigation.space-navigation.header.edit-space-details",
        defaultMessage: "Edit space details"
    }
});



var $ENihE = parcelRequire("ENihE");


























var $28oQf = parcelRequire("28oQf");

const $078c23c8ca6acb4f$export$5ff3b51f9b84be4d = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { links: links } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremiumEdition = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isPremiumEdition || $[2] !== routeDataRef) {
        t1 = (itemId)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "navigationItem",
                        actionSubjectId: "spaceNavigationItem",
                        source: "containerNavigation",
                        attributes: {
                            navigationLayer: "container",
                            itemId: itemId,
                            selectedItemPageContext: routeDataRef.current?.routeName,
                            navVersion: "4",
                            isPremiumEdition: isPremiumEdition
                        }
                    }
                }).fire();
            };
        $[0] = createAnalyticsEvent;
        $[1] = isPremiumEdition;
        $[2] = routeDataRef;
        $[3] = t1;
    } else t1 = $[3];
    const sendItemClickedAnalytics = t1;
    let t2;
    if ($[4] !== sendItemClickedAnalytics) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($078c23c8ca6acb4f$var$CalendarsLink, {
            key: "calendars-link",
            onClick: sendItemClickedAnalytics("calendars")
        });
        $[4] = sendItemClickedAnalytics;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== sendItemClickedAnalytics) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($078c23c8ca6acb4f$var$QuestionsLink, {
            key: "questions-link",
            onClick: sendItemClickedAnalytics("questions"),
            isLegacy: true
        });
        $[6] = sendItemClickedAnalytics;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== links || $[9] !== sendItemClickedAnalytics || $[10] !== t2 || $[11] !== t3) {
        const builtInitemsMapping = {
            [(0, $28oQf.CALENDARS_KEY)]: t2,
            [(0, $28oQf.QUESTIONS_KEY)]: t3,
            ...(0, $9wGTI.fg)("cc_editions_cq_native") && {
                [(0, $28oQf.QUESTIONS_NATIVE_KEY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($078c23c8ca6acb4f$var$QuestionsLink, {
                    key: "questions-native-link",
                    onClick: sendItemClickedAnalytics("questions")
                })
            }
        };
        t4 = links.filter($078c23c8ca6acb4f$var$_temp).sort($078c23c8ca6acb4f$var$_temp2).map((t5)=>{
            const { webItemCompleteKey: webItemCompleteKey } = t5;
            return webItemCompleteKey && builtInitemsMapping[webItemCompleteKey] || null;
        });
        $[8] = links;
        $[9] = sendItemClickedAnalytics;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    const renderedLinks = t4;
    let t5;
    if ($[13] !== renderedLinks) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderedLinks);
        $[13] = renderedLinks;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
});

const $078c23c8ca6acb4f$var$CalendarsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HaydR",
    name: "CalendarsLink",
    loader: async ()=>(await (parcelRequire("eBq5a"))).CalendarsLink
});

const $078c23c8ca6acb4f$var$QuestionsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8uaMN",
    name: "QuestionsLink",
    loader: async ()=>(await (parcelRequire("8Ai3e"))).QuestionsLink
});
function $078c23c8ca6acb4f$var$_temp(link) {
    return Boolean(link && !link.hidden);
}
function $078c23c8ca6acb4f$var$_temp2(a, b) {
    return Number(a.position) - Number(b.position);
}



var $aWrnw = parcelRequire("aWrnw");


const $c83507daffd5a949$var$ErrorView = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "NxOnG",
    name: "ErrorView",
    loader: async ()=>(await (parcelRequire("4vXZ9"))).ErrorView
});

const $c83507daffd5a949$var$SpaceApps = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MuuSQ",
    name: "SpaceApps",
    loader: async ()=>(await (parcelRequire("fyLQb"))).SpaceApps
});
const $c83507daffd5a949$var$spaceLinksStyles = null;
const $c83507daffd5a949$var$SidebarContent = /*#__PURE__*/ (0, $42omo.memo)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_n3tdze3t _kqswh2mm _19pk1wug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}));
const $c83507daffd5a949$var$separatorStyles = null;
const $c83507daffd5a949$var$separatorStylesFallback = null;
const $c83507daffd5a949$export$ec7f7d400376dc53 = (t0)=>{
    const $ = (0, $frIzR.c)(49);
    const { navigationProps: navigationProps, errorProps: errorProps, spaceDetails: spaceDetails } = t0;
    const { loading: loading, hasSpace: hasSpace, space: space, spaceKey: spaceKey, homepageId: homepageId, main: main, quick: quick, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, showShortcutsSection: showShortcutsSection, shouldRenderSpaceApps: shouldRenderSpaceApps, allAppLinks: allAppLinks, allVisibleAppLinks: allVisibleAppLinks, loadingForgeApps: loadingForgeApps, onContentTreeLoadComplete: onContentTreeLoadComplete } = navigationProps;
    const { unhandledError: unhandledError, hasRestrictedError: hasRestrictedError, hasNotFoundError: hasNotFoundError, anonymousAccessQueryError: anonymousAccessQueryError } = errorProps;
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if (unhandledError || hasRestrictedError || hasNotFoundError || anonymousAccessQueryError || !loading && !hasSpace) {
        const t1 = unhandledError || anonymousAccessQueryError;
        let t2;
        if ($[0] !== hasNotFoundError || $[1] !== hasRestrictedError || $[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$ErrorView, {
                unhandledError: t1,
                hasRestrictedError: hasRestrictedError,
                hasNotFoundError: hasNotFoundError
            });
            $[0] = hasNotFoundError;
            $[1] = hasRestrictedError;
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let t1;
    if ($[4] !== spaceDetails) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f43a2e4204022e9$export$533fb76256978163), spaceDetails);
        $[4] = spaceDetails;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expValEquals)("confluence_autonomous_space_curation", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e69b9564388a8a7c$export$8372b97ddec977cb), null);
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== loading) {
        t3 = !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[7] = loading;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== blogsHidden || $[10] !== homepageId || $[11] !== isBlogNavigation || $[12] !== isSpaceAdmin || $[13] !== loading || $[14] !== onContentTreeLoadComplete || $[15] !== onDragDropSuccess || $[16] !== pageTreeFinishedLoading || $[17] !== quick || $[18] !== showShortcutsSection || $[19] !== space || $[20] !== spaceKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5s27v.CommonSpaceNavigationContent), {
            showShortcutsSection: showShortcutsSection,
            space: space,
            spaceKey: spaceKey,
            quick: quick,
            homepageId: homepageId,
            loading: loading,
            isSpaceAdmin: isSpaceAdmin,
            isBlogNavigation: isBlogNavigation,
            blogsHidden: blogsHidden,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            onDragDropSuccess: onDragDropSuccess,
            onContentTreeLoadComplete: onContentTreeLoadComplete
        });
        $[9] = blogsHidden;
        $[10] = homepageId;
        $[11] = isBlogNavigation;
        $[12] = isSpaceAdmin;
        $[13] = loading;
        $[14] = onContentTreeLoadComplete;
        $[15] = onDragDropSuccess;
        $[16] = pageTreeFinishedLoading;
        $[17] = quick;
        $[18] = showShortcutsSection;
        $[19] = space;
        $[20] = spaceKey;
        $[21] = t4;
    } else t4 = $[21];
    let t5;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $gMc0m.default)([
            "_18s8ze3t _1yt4ze3t _qtt8glyw _vjgoze3t"
        ]);
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== loading || $[24] !== main) {
        t6 = loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ENihE.ContainerSkeleton), {
            header: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $078c23c8ca6acb4f$export$5ff3b51f9b84be4d), {
            links: main
        });
        $[23] = loading;
        $[24] = main;
        $[25] = t6;
    } else t6 = $[25];
    let t7;
    if ($[26] !== t5 || $[27] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
            "data-testid": "space-links",
            className: t5
        }, t6);
        $[26] = t5;
        $[27] = t6;
        $[28] = t7;
    } else t7 = $[28];
    let t8;
    if ($[29] !== allAppLinks || $[30] !== allVisibleAppLinks || $[31] !== isSpaceAdmin || $[32] !== loading || $[33] !== loadingForgeApps || $[34] !== shouldRenderSpaceApps || $[35] !== spaceKey) {
        t8 = !loading && !loadingForgeApps && shouldRenderSpaceApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            metric: (0, $aWrnw.SPACE_APPS_METRIC)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$SpaceApps, {
            spaceKey: spaceKey,
            isSpaceAdmin: isSpaceAdmin,
            allAppLinks: allAppLinks,
            allVisibleAppLinks: allVisibleAppLinks
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[29] = allAppLinks;
        $[30] = allVisibleAppLinks;
        $[31] = isSpaceAdmin;
        $[32] = loading;
        $[33] = loadingForgeApps;
        $[34] = shouldRenderSpaceApps;
        $[35] = spaceKey;
        $[36] = t8;
    } else t8 = $[36];
    let t9;
    if ($[37] !== t3 || $[38] !== t4 || $[39] !== t7 || $[40] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$SidebarContent, {
            "data-vc": "space-navigation-sidebar-content"
        }, t3, t4, t7, t8);
        $[37] = t3;
        $[38] = t4;
        $[39] = t7;
        $[40] = t8;
        $[41] = t9;
    } else t9 = $[41];
    let t10;
    if ($[42] !== isNav4Enabled || $[43] !== loading) {
        t10 = isNav4Enabled && !loading && (0, $9wGTI.fg)("nav4_global_links_confluence") && ((0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itze3t _195gxmi2 _n7zlia51 _19pkutpp"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itidpf _195gxmi2 _n7zlia51 _19pkutpp"
            ])
        }));
        $[42] = isNav4Enabled;
        $[43] = loading;
        $[44] = t10;
    } else t10 = $[44];
    let t11;
    if ($[45] !== t1 || $[46] !== t10 || $[47] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2, t9, t10);
        $[45] = t1;
        $[46] = t10;
        $[47] = t9;
        $[48] = t11;
    } else t11 = $[48];
    return t11;
};
module.exports["SpaceNavigationContent"] = $c83507daffd5a949$export$ec7f7d400376dc53;

});

parcelRegister("1I9Gw", function(module, exports) {
const $f0a04d35c062874d$export$1598149f6f3f7d46 = (spaceKey)=>{
    return spaceKey?.[0] === '~';
};
module.exports["isPersonalSpace"] = $f0a04d35c062874d$export$1598149f6f3f7d46;

});

parcelRegister("7aA9P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");

class $538583af869725c3$export$b170112dc71045f1 extends (0, $42omo.PureComponent) {
    render() {
        const props = Object.assign({}, this.props);
        if ((this.state.error || !props.src) && props.fallback) {
            if (typeof props.fallback === 'string') props.src = props.fallback;
            else if (typeof props.fallback === 'function') return props.fallback();
        }
        delete props.fallback;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            ...props,
            alt: props.alt || '',
            onError: this.onError
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: false
        };
        this.onError = ()=>{
            this.setState({
                error: true
            });
        };
    }
}
$538583af869725c3$export$b170112dc71045f1.propTypes = {
    fallback: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    ])
};
module.exports["FallbackableImage"] = $538583af869725c3$export$b170112dc71045f1;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $4VJDS.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("jZM59", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $e6220385bdb59eee$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $e6220385bdb59eee$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $42omo.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $ee7An.default),
    collapseLeftSidebar: (0, $ee7An.default),
    leftSidebarState: $e6220385bdb59eee$var$leftSidebarState,
    setLeftSidebarState: (0, $ee7An.default),
    toggleLeftSidebar: (0, $ee7An.default)
});
const $e6220385bdb59eee$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $42omo.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    return context;
};
const $e6220385bdb59eee$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $42omo.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    (0, $42omo.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};
module.exports["usePageLayoutResize"] = $e6220385bdb59eee$export$10c7104037a7af62;
module.exports["useLeftSidebarFlyoutLock"] = $e6220385bdb59eee$export$94561f6055639ef7;

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("9x2sR", function(module, exports) {
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $eLJ8w = parcelRequire("eLJ8w");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");

const $a9268ffbf811ea39$var$listItemStyles = {
    root: "_10m98stt"
};
const $a9268ffbf811ea39$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $42omo.useRef)(null);
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eLJ8w.ListItem), {
        ref: ref,
        xcss: $a9268ffbf811ea39$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $a9268ffbf811ea39$export$d2cad7a1cce7b35f = (0, $3hoG4.default)($a9268ffbf811ea39$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $a9268ffbf811ea39$export$d2cad7a1cce7b35f;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("fDC7w", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $6BXcn = parcelRequire("6BXcn");

function $4023ab33a3161118$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $4023ab33a3161118$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $42omo.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $42omo.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $dRnqM.default)(element, 'Element ref must be set');
            $4023ab33a3161118$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}
module.exports["useScrollMenuItemIntoView"] = $4023ab33a3161118$export$2c52ec851fcc6058;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $42omo.isValidElement)(children) ? /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) {
        if ((0, $6mKj3.expVal)('platform_editor_hydratable_ui', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": `hover-preloader-${props.name}`,
            "data-testid": "hover-preloader"
        }, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("fIdAJ"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("fIdAJ", function(module, exports) {

let $b7058211b83db610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7058211b83db610$var$load("kyxdN").then(()=>parcelRequire('asonV'));

});

parcelRegister("6lvbX", function(module, exports) {

var $hdRN9 = parcelRequire("hdRN9");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $jMyy4 = parcelRequire("jMyy4");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $a3fRD = parcelRequire("a3fRD");


var $eXmBZ = parcelRequire("eXmBZ");


var $6xdDU = parcelRequire("6xdDU");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $7QM6o = parcelRequire("7QM6o");


var $cLo2u = parcelRequire("cLo2u");


var $13WZn = parcelRequire("13WZn");

const $e305cd57fd097c2e$var$ExternalCollaboratorsSpaceInformationMessageQuery = (0, $hdRN9.default);
const $e305cd57fd097c2e$var$i18n = (0, $cgtv4.defineMessages)({
    spaceNavigationMessageLink: {
        id: "space-guest-list.external-collaborator-message.navigation.guests-access-to-space",
        defaultMessage: "{guestCallToAction} in this space"
    },
    spaceMessageLink: {
        id: "space-guest-list.external-collaborator-message.space.guests-access-to-space",
        defaultMessage: "{guestCallToAction} {guestCount, plural, one {has} other {have}} access to this space."
    },
    pageMessageLink: {
        id: "space-guest-list.external-collaborator-message.page.guests-access-to-page",
        defaultMessage: "{guestCallToAction} can access."
    },
    pageMessageLinkWithSeparateCallToAction: {
        id: "space-guest-list.external-collaborator-message.page.guests-access-to-page-cta",
        defaultMessage: "{guests} can access. {callToAction}"
    },
    additionalContextMessage: {
        id: "space-guest-list.external-collaborator-message.guest-context",
        defaultMessage: "Guests are external to your organization."
    },
    guestCallToActionMessage: {
        id: "space-guest-list.external-collaborator-message.guest-count",
        defaultMessage: "{guestCount, plural, =0 {No guests} one {# guest} other {# guests}}"
    },
    callToActionMessage: {
        id: "space-guest-list.external-collaborator-message.view-guest-action",
        defaultMessage: "{guestCount, plural, one {View guest} other {View guests}}"
    },
    errorMessage: {
        id: "space-guest-list.external-collaborator-message.error",
        defaultMessage: "An error occurred while retrieving guests."
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e305cd57fd097c2e$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulppxbi _1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e305cd57fd097c2e$var$IconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e305cd57fd097c2e$var$MessageWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSubtlest: isSubtlest, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw",
            __cmplp.isSubtlest ? "_syaz1rpy" : "_syazazsu",
            __cmplp.className
        ])
    });
});
const $e305cd57fd097c2e$var$MessageButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSubtlest: isSubtlest, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19zy1r31 _5fak8stv _q1zanqa1 _13gm1r31 _gms98stv _1ddtnqa1 _143jazsu",
            __cmplp.isSubtlest ? "_8avf1rpy" : "_8avfazsu",
            __cmplp.className
        ])
    });
});
const $e305cd57fd097c2e$var$NullButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.className
        ])
    });
});
const $e305cd57fd097c2e$var$MessageSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2rko12b0 _1e0c1txw _bfhki8nm",
            __cmplp.className
        ])
    });
});
var $e305cd57fd097c2e$export$d804669af4df8a67 = /*#__PURE__*/ function(ExternalCollaboratorsSpaceInformationMessageType) {
    ExternalCollaboratorsSpaceInformationMessageType["IN_SPACE"] = "IN_SPACE";
    ExternalCollaboratorsSpaceInformationMessageType["ACCESS_TO_SPACE"] = "ACCESS_TO_SPACE";
    ExternalCollaboratorsSpaceInformationMessageType["ACCESS_TO_PAGE"] = "ACCESS_TO_PAGE";
    ExternalCollaboratorsSpaceInformationMessageType["ACCESS_TO_PAGE_CTA"] = "ACCESS_TO_PAGE_CTA";
    return ExternalCollaboratorsSpaceInformationMessageType;
}({});
const $e305cd57fd097c2e$var$PRIMARY_MESSAGE = {
    ["IN_SPACE"]: $e305cd57fd097c2e$var$i18n.spaceNavigationMessageLink,
    ["ACCESS_TO_SPACE"]: $e305cd57fd097c2e$var$i18n.spaceMessageLink,
    ["ACCESS_TO_PAGE"]: $e305cd57fd097c2e$var$i18n.pageMessageLink,
    ["ACCESS_TO_PAGE_CTA"]: $e305cd57fd097c2e$var$i18n.pageMessageLinkWithSeparateCallToAction
};
const $e305cd57fd097c2e$var$getPrimaryMessage = (messageType)=>{
    return $e305cd57fd097c2e$var$PRIMARY_MESSAGE[messageType] ?? $e305cd57fd097c2e$var$i18n.spaceMessageLink;
};
const $e305cd57fd097c2e$var$ANALYTICS_SOURCE_MODAL_DIALOG = 'viewExternalCollaboratorsModalDialog';
const $e305cd57fd097c2e$export$cbb9594d20a6fe04 = ({ analyticsSource: analyticsSource, messageType: messageType, shouldShowMessageIcon: shouldShowMessageIcon, shouldShowAdditionalMessageContext: shouldShowAdditionalMessageContext, spaceKey: propSpaceKey, onLoadComplete: onLoadComplete, onLoadError: onLoadError, isSubtle: isSubtle, dontRecolorGuestCount: dontRecolorGuestCount })=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)(propSpaceKey);
    const spaceId = (0, $7QM6o.useSpaceId)(propSpaceKey);
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const isSubtlest = !!isSubtle;
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($e305cd57fd097c2e$var$ExternalCollaboratorsSpaceInformationMessageQuery, {
        variables: {
            spaceKey: spaceKey
        }
    });
    const guestCount = data?.space?.externalCollaboratorCount ?? 0;
    (0, $42omo.useEffect)(()=>{
        if (error) onLoadError?.(error);
    }, [
        error,
        onLoadError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading) onLoadComplete?.({
            guestCount: guestCount
        });
    }, [
        guestCount,
        loading,
        onLoadComplete
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onButtonClick = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'viewGuestsList',
                source: analyticsSource,
                containerType: 'space',
                containerId: spaceId
            }
        }).fire();
        setIsModalOpen(true);
    }, [
        createAnalyticsEvent,
        spaceId,
        analyticsSource
    ]);
    const onClose = ()=>{
        setIsModalOpen(false);
    };
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).EXTERNAL_COLLAB
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$IconWrapper, {
        hidden: !shouldShowMessageIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$MessageWrapper, {
        isSubtlest: isSubtlest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e305cd57fd097c2e$var$i18n.errorMessage)))));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$MessageSkeleton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)));
    const CtaComponent = dontRecolorGuestCount ? $e305cd57fd097c2e$var$NullButtonWrapper : $e305cd57fd097c2e$var$MessageButtonWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$Wrapper, null, shouldShowMessageIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
        spacing: "spacious",
        color: "var(--ds-icon-information, #357DE8)",
        label: "info"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$MessageWrapper, {
        isSubtlest: isSubtlest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$e305cd57fd097c2e$var$getPrimaryMessage(messageType),
        values: {
            guestCount: guestCount,
            guests: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$e305cd57fd097c2e$var$i18n.guestCallToActionMessage,
                values: {
                    guestCount: guestCount
                }
            }),
            guestCallToAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CtaComponent, {
                "data-testid": "view-external-collaborators-link",
                isSubtlest: isSubtlest
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "link",
                spacing: "none",
                onClick: onButtonClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$e305cd57fd097c2e$var$i18n.guestCallToActionMessage,
                values: {
                    guestCount: guestCount
                }
            }))),
            callToAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "link",
                spacing: "none",
                onClick: onButtonClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$e305cd57fd097c2e$var$i18n.callToActionMessage,
                values: {
                    guestCount: guestCount
                }
            }))
        }
    }), shouldShowAdditionalMessageContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e305cd57fd097c2e$var$i18n.additionalContextMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13WZn.ViewSpaceExternalCollaboratorsDialogLoadable), {
        spaceKey: spaceKey || '',
        hasHeaderImage: false,
        onClose: onClose,
        onCloseComplete: ()=>{},
        analyticsSource: $e305cd57fd097c2e$var$ANALYTICS_SOURCE_MODAL_DIALOG,
        clickSource: analyticsSource
    })));
};
module.exports["ExternalCollaboratorsSpaceInformationMessageType"] = $e305cd57fd097c2e$export$d804669af4df8a67;
module.exports["ExternalCollaboratorsSpaceInformationMessage"] = $e305cd57fd097c2e$export$cbb9594d20a6fe04;

});

parcelRegister("hdRN9", function(module, exports) {
/**
 * @generated SignedSource<<ee134fc99b05f425fd206779f25f1cdf>>
 * @relayHash 32a952014d67b0057adc7b01553cbb8d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59aea14d53b9d666582c86e38ca652d828e911e876a43cf207a50c947919c769
const $a53bf567f7c11134$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "externalCollaboratorCount"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalCollaboratorsSpaceInformationMessageQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalCollaboratorsSpaceInformationMessageQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "32a952014d67b0057adc7b01553cbb8d",
            "id": "59aea14d53b9d666582c86e38ca652d828e911e876a43cf207a50c947919c769",
            "metadata": {},
            "name": "ExternalCollaboratorsSpaceInformationMessageQuery",
            "operationKind": "query",
            "text": "query ExternalCollaboratorsSpaceInformationMessageQuery($spaceKey:String){space(key:$spaceKey){id,name,externalCollaboratorCount,currentUser{isAdmin}}}"
        }
    };
}();
$a53bf567f7c11134$var$node.hash = "930fa48aeb29519bd20c8cdd9958c15b";
var $a53bf567f7c11134$export$2e2bcd8739ae039 = $a53bf567f7c11134$var$node;
module.exports["default"] = $a53bf567f7c11134$export$2e2bcd8739ae039;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("13WZn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8d0dcdd220890645$export$9a1f6434985b7141 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2jSJc",
    name: "ViewSpaceExternalCollaboratorsDialogLoadable",
    loader: async ()=>(await (parcelRequire("2EBCF"))).ViewSpaceExternalCollaboratorsDialog
});
module.exports["ViewSpaceExternalCollaboratorsDialogLoadable"] = $8d0dcdd220890645$export$9a1f6434985b7141;

});

parcelRegister("2EBCF", function(module, exports) {

let $1eec8044ee52081d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1eec8044ee52081d$var$load("hhss7"),
    $1eec8044ee52081d$var$load("l5XQ1")
]).then(()=>parcelRequire('l9IRD'));

});

parcelRegister("jrref", function(module, exports) {
/* hide.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $7ca6755ada461d2d$var$styles = {
    'above.xs': "_114bglyw",
    'above.sm': "_181nglyw",
    'above.md': "_dm25glyw",
    'above.lg': "_je3oglyw",
    'above.xl': "_1uxvglyw",
    'below.xs': "_1m0aglyw",
    'below.sm': "_sugaglyw",
    'below.md': "_1mjbglyw",
    'below.lg': "_liwcglyw",
    'below.xl': "_14wzglyw"
};
const $7ca6755ada461d2d$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(AsElement, {
        className: (0, $gMc0m.default)([
            above && $7ca6755ada461d2d$var$styles[`above.${above}`],
            below && $7ca6755ada461d2d$var$styles[`below.${below}`],
            xcss
        ]),
        children: children
    });
};
module.exports["Hide"] = $7ca6755ada461d2d$export$bed28288a051538;

});

parcelRegister("3SChL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $751fcd22fac4dec6$export$7a357837346c6789 = {
    editor: [
        'nth-user-orientation-editor-space-spotlight',
        'nth-user-orientation-editor-for-you-spotlight',
        'nth-user-orientation-editor-bpqa-spotlight'
    ]
};
const $751fcd22fac4dec6$var$detectTour = (renderedSpotlights)=>{
    // Find the first tour where all required spotlights are registered
    for (const [tour, spotlights] of Object.entries($751fcd22fac4dec6$export$7a357837346c6789)){
        if (spotlights.every((spotlight)=>renderedSpotlights.has(spotlight))) return tour;
    }
    return null;
};
const $751fcd22fac4dec6$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        active: false,
        step: 0,
        renderedSpotlights: new Set(),
        hasInteracted: false
    },
    actions: {
        activate: ()=>({ setState: setState })=>{
                setState({
                    active: true,
                    step: 0
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState({
                    active: false,
                    step: 0,
                    hasInteracted: false
                });
            },
        next: ()=>({ setState: setState, getState: getState })=>{
                const nextStep = Math.min(getState().step + 1, 2);
                setState({
                    step: nextStep,
                    hasInteracted: true
                });
            },
        back: ()=>({ setState: setState, getState: getState })=>{
                const prevStep = Math.max(getState().step - 1, 0);
                setState({
                    step: prevStep,
                    hasInteracted: true
                });
            },
        registerSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.add(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            },
        deregisterSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.delete(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            }
    },
    name: 'experiment-nth-user-orientation-store'
});
const $751fcd22fac4dec6$export$6d3060c9729a9bf7 = (0, $9zUhf.createStateHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$31ec7099503725e8 = (0, $9zUhf.createActionsHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$e9b94d8bc34db24 = (spotlightId)=>{
    const { next: next, back: back, reset: reset, registerSpotlight: registerSpotlight, deregisterSpotlight: deregisterSpotlight } = $751fcd22fac4dec6$export$31ec7099503725e8();
    const { step: step, active: active, renderedSpotlights: renderedSpotlights, hasInteracted: hasInteracted } = $751fcd22fac4dec6$export$6d3060c9729a9bf7();
    // Auto-register/deregister the spotlight when spotlights use this hook. This way
    // we can keep track of which spotlights are currently rendered, and use that list
    // to figure out if the user is eligible for a tour.
    (0, $42omo.useEffect)(()=>{
        registerSpotlight({
            spotlightId: spotlightId
        });
        return ()=>{
            deregisterSpotlight({
                spotlightId: spotlightId
            });
        };
    }, [
        spotlightId,
        registerSpotlight,
        deregisterSpotlight
    ]);
    const detectedTour = (0, $42omo.useMemo)(()=>$751fcd22fac4dec6$var$detectTour(renderedSpotlights), [
        renderedSpotlights
    ]);
    if (!active || !detectedTour) return {
        reset: reset,
        back: back,
        next: next,
        currentStep: null,
        progress: {
            step: 0,
            steps: 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
    return {
        reset: reset,
        back: back,
        next: next,
        currentStep: $751fcd22fac4dec6$export$7a357837346c6789[detectedTour][step],
        progress: {
            step: step + 1,
            steps: detectedTour ? $751fcd22fac4dec6$export$7a357837346c6789[detectedTour].length : 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
};
module.exports["useNthUserOrientationState"] = $751fcd22fac4dec6$export$6d3060c9729a9bf7;
module.exports["useNthUserOrientationActions"] = $751fcd22fac4dec6$export$31ec7099503725e8;
module.exports["useTour"] = $751fcd22fac4dec6$export$e9b94d8bc34db24;

});

parcelRegister("3Awqk", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $90247d71b6534bef$export$ce22f6f6b0034afd = (0, $cgtv4.defineMessages)({
    next: {
        id: "experiment-nth-user-orientation.spotlight.next",
        defaultMessage: "Next"
    },
    back: {
        id: "experiment-nth-user-orientation.spotlight.back",
        defaultMessage: "Back"
    },
    done: {
        id: "experiment-nth-user-orientation.spotlight.done",
        defaultMessage: "Done"
    },
    dismiss: {
        id: "experiment-nth-user-orientation.spotlight.dismiss",
        defaultMessage: "Dismiss Tour"
    },
    progress: {
        id: "experiment-nth-user-orientation.spotlight.progress",
        defaultMessage: "{step} of {steps}"
    }
});
const $90247d71b6534bef$export$9a4454cd199ce080 = (0, $cgtv4.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.headline",
        defaultMessage: "Your space, your start"
    },
    body: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.body",
        defaultMessage: "This is your personal space. Create more to organize your team\u2019s work."
    }
});
const $90247d71b6534bef$export$252e22890fb2efa6 = (0, $cgtv4.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.headline",
        defaultMessage: "Catch up on team activity here"
    },
    body: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.body",
        defaultMessage: "See recent pages, team updates, and quick links tailored for you."
    }
});
const $90247d71b6534bef$export$6794fada8079fe55 = (0, $cgtv4.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.headline",
        defaultMessage: "Now let\u2019s create your first page!"
    },
    body: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.body",
        defaultMessage: "With a template, a page is a click away. Hover on one for a preview."
    }
});
module.exports["spotlight"] = $90247d71b6534bef$export$ce22f6f6b0034afd;
module.exports["editorSpaceSpotlight"] = $90247d71b6534bef$export$9a4454cd199ce080;
module.exports["editorForYouSpotlight"] = $90247d71b6534bef$export$252e22890fb2efa6;
module.exports["editorBpqaSpotlight"] = $90247d71b6534bef$export$6794fada8079fe55;

});

parcelRegister("2AgON", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS = {
    'nth-user-orientation-editor-space-spotlight': 'nthUserOrientationEditorSpaceSpotlight',
    'nth-user-orientation-editor-for-you-spotlight': 'nthUserOrientationEditorForYouSpotlight',
    'nth-user-orientation-editor-bpqa-spotlight': 'nthUserOrientationEditorBpqaSpotlight'
};
function $3c36b21fe0d55bcd$export$b54fada573f13a91({ spotlightId: spotlightId, isVisible: isVisible, onNext: onNext, onBack: onBack, onDismiss: onDismiss }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // Fire render event when spotlight becomes visible
    (0, $42omo.useEffect)(()=>{
        if (isVisible) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'spotlight',
                actionSubjectId: $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS[spotlightId],
                source: 'nth-user-orientation'
            }
        }).fire();
    }, [
        isVisible,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleNext = (0, $42omo.useCallback)(()=>{
        if (onNext) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'next',
                    source: spotlightId
                }
            }).fire();
            onNext();
        }
    }, [
        onNext,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleBack = (0, $42omo.useCallback)(()=>{
        if (onBack) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'back',
                    source: spotlightId
                }
            }).fire();
            onBack();
        }
    }, [
        onBack,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissTour',
                source: spotlightId
            }
        }).fire();
        onDismiss();
    }, [
        onDismiss,
        createAnalyticsEvent,
        spotlightId
    ]);
    return {
        handleNext: onNext ? handleNext : undefined,
        handleBack: onBack ? handleBack : undefined,
        handleDismiss: handleDismiss
    };
}
module.exports["useSpotlightAnalytics"] = $3c36b21fe0d55bcd$export$b54fada573f13a91;

});

parcelRegister("35Nok", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cOrQJ = parcelRequire("cOrQJ");

const $cd2e96a49affba4b$export$4b64aca38e15f2eb = ({ gif: gif, placeholder: placeholder, skip: skip = false })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const gifSrc = gif[colorMode ?? 'light'];
    const placeholderSrc = placeholder[colorMode ?? 'light'];
    const [isReady, setIsReady] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        setIsReady(false);
        const image = new Image();
        image.onload = ()=>{
            setIsReady(true);
        };
        image.onerror = ()=>{
            setIsReady(false);
        };
        image.src = gifSrc;
        // If the image has already loaded (cached), handle it immediately
        if (image.complete) setIsReady(true);
    }, [
        gifSrc,
        skip
    ]);
    return isReady ? gifSrc : placeholderSrc;
};
module.exports["usePreloadGif"] = $cd2e96a49affba4b$export$4b64aca38e15f2eb;

});

parcelRegister("eGUIL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6ab3d9f83e467c30$export$8ff51aff18368071 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $6ab3d9f83e467c30$export$18d9743f01f9c283 = ()=>{
    const context = (0, $42omo.useContext)($6ab3d9f83e467c30$export$8ff51aff18368071);
    if (!context) throw new Error("useSideNavigation must be used within a SideNavigationContext.Provider");
    return context;
};
module.exports["SideNavigationContext"] = $6ab3d9f83e467c30$export$8ff51aff18368071;
module.exports["useSideNavigation"] = $6ab3d9f83e467c30$export$18d9743f01f9c283;

});

parcelRegister("l4aBp", function(module, exports) {

var $kGPEj = parcelRequire("kGPEj");


var $jFpJO = parcelRequire("jFpJO");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $3gadb = parcelRequire("3gadb");


var $56M4r = parcelRequire("56M4r");


var $inPa6 = parcelRequire("inPa6");


var $clKWq = parcelRequire("clKWq");


var $lRalB = parcelRequire("lRalB");


var $308Wd = parcelRequire("308Wd");

const $7bb55d8f5cb503c4$export$4bee8aa478fda9c7 = ({ spaceId: spaceId, isWatched: isWatched, onWatch: onWatch, onUnwatch: onUnwatch, analytics: analytics, inMenu: inMenu = false })=>{
    const intl = (0, $8C5kA.default)();
    const [watchSpace] = (0, $308Wd.useMutationInterop)((0, $jFpJO.default), {
        optimisticResponse: {
            __typename: 'Mutation',
            watchSpace: {
                __typename: 'WatchSpacePayload',
                space: {
                    __typename: 'Space',
                    id: spaceId,
                    currentUser: {
                        __typename: 'SpaceUserMetadata',
                        isWatched: true
                    }
                }
            }
        }
    });
    const [unWatchSpace] = (0, $308Wd.useMutationInterop)((0, $kGPEj.default), {
        optimisticResponse: {
            __typename: 'Mutation',
            unwatchSpace: {
                __typename: 'WatchSpacePayload',
                space: {
                    __typename: 'Space',
                    id: spaceId,
                    currentUser: {
                        __typename: 'SpaceUserMetadata',
                        isWatched: false
                    }
                }
            }
        }
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)((e)=>{
        if (isWatched) onUnwatch && onUnwatch(e);
        else onWatch && onWatch(e);
        const mutation = isWatched ? unWatchSpace : watchSpace;
        mutation({
            variables: {
                spaceId: spaceId
            }
        });
        if (analytics) {
            const { source: source, containerId: containerId, attributes: attributes } = analytics;
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: isWatched ? 'unwatched' : 'watched',
                    actionSubject: 'space',
                    source: source,
                    attributes: attributes,
                    ...containerId && {
                        containerId: containerId
                    }
                }
            }).fire();
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        spaceId,
        isWatched,
        analytics,
        watchSpace,
        unWatchSpace,
        createAnalyticsEvent
    ]);
    const watchTooltip = isWatched ? $7bb55d8f5cb503c4$var$i18n.Unwatch : $7bb55d8f5cb503c4$var$i18n.Watch;
    const watchIconButton = isWatched ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $clKWq.FilledIconButton), {
        onClick: handleClick,
        "data-testid": "actions-watched",
        "aria-label": intl.formatMessage($7bb55d8f5cb503c4$var$i18n.Watch),
        "aria-pressed": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lRalB.WatchIcon), {
        isWatched: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $clKWq.UnfilledIconButton), {
        onClick: handleClick,
        "data-testid": "actions-unwatched",
        "aria-label": intl.formatMessage($7bb55d8f5cb503c4$var$i18n.Watch),
        "aria-pressed": false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lRalB.WatchIcon), {
        isWatched: false
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, inMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        testId: "watch-menu-item",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lRalB.WatchIcon), {
            isWatched: isWatched
        }),
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), watchTooltip)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), watchTooltip),
        hideTooltipOnMouseDown: true
    }, watchIconButton));
};
const $7bb55d8f5cb503c4$var$i18n = (0, $cgtv4.defineMessages)({
    Watch: {
        id: "action-buttons.space.watch",
        defaultMessage: "Watch space"
    },
    Unwatch: {
        id: "action-buttons.space.unwatch",
        defaultMessage: "Unwatch space"
    }
});
module.exports["SpaceWatchButton"] = $7bb55d8f5cb503c4$export$4bee8aa478fda9c7;

});

parcelRegister("kGPEj", function(module, exports) {
/**
 * @generated SignedSource<<3ffa3ac436bed8266e1aa6d0fa65db88>>
 * @relayHash 4cfae0931b26b83ef93ac740f364c4ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e07aea790ec67791280e229850672a9c0fbe0b50827c6afacb9dfff48a3e5c38
const $384953bc44a36fbe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceId",
                            "variableName": "spaceId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchSpaceInput"
                }
            ],
            "concreteType": "WatchSpacePayload",
            "kind": "LinkedField",
            "name": "unwatchSpace",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatched"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceWatchButtonSpaceDirectoryUnWatchSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceWatchButtonSpaceDirectoryUnWatchSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4cfae0931b26b83ef93ac740f364c4ad",
            "id": "e07aea790ec67791280e229850672a9c0fbe0b50827c6afacb9dfff48a3e5c38",
            "metadata": {},
            "name": "SpaceWatchButtonSpaceDirectoryUnWatchSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation SpaceWatchButtonSpaceDirectoryUnWatchSpaceMutation($spaceId:ID!){unwatchSpace(watchSpaceInput:{spaceId:$spaceId,currentUser:true}){space{id,currentUser{isWatched}}}}"
        }
    };
}();
$384953bc44a36fbe$var$node.hash = "a4f177be3ac1e0ec5d184466e2a6c9d3";
var $384953bc44a36fbe$export$2e2bcd8739ae039 = $384953bc44a36fbe$var$node;
module.exports["default"] = $384953bc44a36fbe$export$2e2bcd8739ae039;

});

parcelRegister("jFpJO", function(module, exports) {
/**
 * @generated SignedSource<<41211e1ed232a0ef3c551dfdbd0ef359>>
 * @relayHash b3188a733e91e77e1d841a4c850c4ea8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aac189c3618b5c01f79fc57a3308a7060df074104faf7c80cd08661e1401ef11
const $02e41e53bcd7651c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceId",
                            "variableName": "spaceId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchSpaceInput"
                }
            ],
            "concreteType": "WatchSpacePayload",
            "kind": "LinkedField",
            "name": "watchSpace",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatched"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceWatchButtonSpaceDirectoryWatchSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceWatchButtonSpaceDirectoryWatchSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b3188a733e91e77e1d841a4c850c4ea8",
            "id": "aac189c3618b5c01f79fc57a3308a7060df074104faf7c80cd08661e1401ef11",
            "metadata": {},
            "name": "SpaceWatchButtonSpaceDirectoryWatchSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation SpaceWatchButtonSpaceDirectoryWatchSpaceMutation($spaceId:ID!){watchSpace(watchSpaceInput:{spaceId:$spaceId,currentUser:true}){space{id,currentUser{isWatched}}}}"
        }
    };
}();
$02e41e53bcd7651c$var$node.hash = "bb879e2957ad1427e2b90c8fe4d56a44";
var $02e41e53bcd7651c$export$2e2bcd8739ae039 = $02e41e53bcd7651c$var$node;
module.exports["default"] = $02e41e53bcd7651c$export$2e2bcd8739ae039;

});

parcelRegister("clKWq", function(module, exports) {
/* PresentationalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $eEA8O = parcelRequire("eEA8O");

const $c778e820ae925f4a$var$buttonStyle = null;
const $c778e820ae925f4a$export$51d63fc44de8b04c = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _11q7sm61 _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _19lc1dpa",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c778e820ae925f4a$export$d4589334c0881f2b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _11q7sm61 _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _syaz173l _19lc1dpa _1fh11q3r",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$7099540c149f2cd6 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1t4p14lu _ll8p1q3r",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$4fba02bb1c3a731d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bgrb1eg2 _yfoxkb7n",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$5df393b96cc674b9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _11q7sm61 _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _bgrb1eg2 _yfoxkb7n _19lc1dpa",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$e74173003a1ed83f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1dgtmw9": (0, $7sObp.default)(__cmplp.isHidden ? 'var(--show-action)' : '1')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bgrb1dxe _yfoxkb7n",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$bba53dc78bc0e0ef = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isSubtle && "_1s9r14lu _ewrd1q3r",
            __cmplp.className
        ])
    });
});
module.exports["FilledIconButton"] = $c778e820ae925f4a$export$51d63fc44de8b04c;
module.exports["UnfilledIconButton"] = $c778e820ae925f4a$export$d4589334c0881f2b;
module.exports["HoverButton"] = $c778e820ae925f4a$export$7099540c149f2cd6;
module.exports["HiddenAction"] = $c778e820ae925f4a$export$4fba02bb1c3a731d;
module.exports["ConditionalHiddenAction"] = $c778e820ae925f4a$export$e74173003a1ed83f;
module.exports["ConditionalSubtleHoverButton"] = $c778e820ae925f4a$export$bba53dc78bc0e0ef;

});

parcelRegister("lRalB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fCjCI = parcelRequire("fCjCI");


var $8cjip = parcelRequire("8cjip");

const $221421ab29b48be7$export$b08d361543783c05 = ({ isWatched: isWatched })=>{
    return isWatched ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fCjCI))), {
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
        label: "",
        color: "currentColor"
    });
};
module.exports["WatchIcon"] = $221421ab29b48be7$export$b08d361543783c05;

});

parcelRegister("iquRY", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $frIzR.c)(6);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            variables: {
                cloudId: cloudId
            },
            onError: $cccaa992351fdb79$var$_temp
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), t0);
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t1 = data?.confluence_spaceRoleMode;
    let t2;
    if ($[2] !== isNotPreRoles || $[3] !== loading || $[4] !== t1) {
        t2 = {
            spaceRoleMode: t1,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[2] = isNotPreRoles;
        $[3] = loading;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<fca40edcd431a6c5f3bb28df1ad0109c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("1o4fX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hqNcO = parcelRequire("hqNcO");

function $560b1fdf6e9d95bc$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $hqNcO.MILLISECONDS_IN_A_DAY));
}
function $560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $560b1fdf6e9d95bc$export$954628993bf3188e(trialEndTime - Date.now());
}
function $560b1fdf6e9d95bc$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $560b1fdf6e9d95bc$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $560b1fdf6e9d95bc$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $560b1fdf6e9d95bc$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $560b1fdf6e9d95bc$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $560b1fdf6e9d95bc$export$ee6c4faab08346c;

});

parcelRegister("hqNcO", function(module, exports) {
const $f5358d62f394b358$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $f5358d62f394b358$export$98a7370239de6730;

});

parcelRegister("3P1RK", function(module, exports) {

var $fHoxN = parcelRequire("fHoxN");

var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    SpacePermissionsTabKey["Apps"] = "apps";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};
module.exports["SpacePermissionsTabKey"] = $4a56ff9e2636e665$export$ad59ff7dc414850a;
module.exports["SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP"] = $4a56ff9e2636e665$export$d4f1d7ffc41e2d29;

});

parcelRegister("fHoxN", function(module, exports) {
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["PermissionDisplayType"] = $8a20bb30841ead37$export$f1a726cdbae0d72a;
module.exports["SpacePermissionType"] = $8a20bb30841ead37$export$a99f5dae9c149910;

});

parcelRegister("jAO76", function(module, exports) {

let $e4384098ddb383b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4384098ddb383b3$var$load("860dT").then(()=>parcelRequire('8KFPL'));

});

parcelRegister("28oQf", function(module, exports) {
const $a5e3205ff2d8ec91$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-space-analytics';
const $a5e3205ff2d8ec91$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-moderate-space-analytics';
const $a5e3205ff2d8ec91$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-automation';
const $a5e3205ff2d8ec91$export$dad26f289a3f773e = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-blogs';
const $a5e3205ff2d8ec91$export$27d01545acc1e1ca = 'com.atlassian.confluence.extra.team-calendars:space-calendar-sidebar-link';
const $a5e3205ff2d8ec91$export$a1081c7e806b45a0 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-k15t-orderly-databases-database';
const $a5e3205ff2d8ec91$export$de45ec31104af09 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-atlassian-confluence-plugins-confluence-questions-question';
const $a5e3205ff2d8ec91$export$1b86edccef2dd51 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-questions';
const $a5e3205ff2d8ec91$export$f618e448a4ddfafa = 'com.atlassian.confluence.plugins.confluence-frontend-support:space-tools-link';
const $a5e3205ff2d8ec91$export$9727611105a72ba4 = 'com.atlassian.plugins.atlassian-connect-plugin';
const $a5e3205ff2d8ec91$export$35d69df876e79a8b = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-shortcuts';
const $a5e3205ff2d8ec91$export$28596511f20e98f2 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-apps';
const $a5e3205ff2d8ec91$export$1c0f21b83a6a96d6 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-content-manager';
module.exports["ANALYTICS_KEY"] = $a5e3205ff2d8ec91$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $a5e3205ff2d8ec91$export$6c3d789a4f56bea2;
module.exports["AUTOMATION_KEY"] = $a5e3205ff2d8ec91$export$ee99bc1ad01a63ae;
module.exports["BLOG_KEY"] = $a5e3205ff2d8ec91$export$dad26f289a3f773e;
module.exports["CALENDARS_KEY"] = $a5e3205ff2d8ec91$export$27d01545acc1e1ca;
module.exports["DATABASES_KEY"] = $a5e3205ff2d8ec91$export$a1081c7e806b45a0;
module.exports["QUESTIONS_KEY"] = $a5e3205ff2d8ec91$export$de45ec31104af09;
module.exports["QUESTIONS_NATIVE_KEY"] = $a5e3205ff2d8ec91$export$1b86edccef2dd51;
module.exports["SPACE_SETTINGS_KEY"] = $a5e3205ff2d8ec91$export$f618e448a4ddfafa;
module.exports["CONNECT_ADDON_KEY"] = $a5e3205ff2d8ec91$export$9727611105a72ba4;
module.exports["SHORTCUTS_KEY"] = $a5e3205ff2d8ec91$export$35d69df876e79a8b;
module.exports["APPS_KEY"] = $a5e3205ff2d8ec91$export$28596511f20e98f2;
module.exports["BULK_TOOLS_KEY"] = $a5e3205ff2d8ec91$export$1c0f21b83a6a96d6;

});

parcelRegister("eBq5a", function(module, exports) {

let $aa18c0cad27925d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa18c0cad27925d9$var$load("6wr18"),
    $aa18c0cad27925d9$var$load("ffEVr"),
    $aa18c0cad27925d9$var$load("c08ou")
]).then(()=>parcelRequire('99rcJ'));

});

parcelRegister("8Ai3e", function(module, exports) {

let $63ffb01b27107377$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63ffb01b27107377$var$load("6wr18"),
    $63ffb01b27107377$var$load("ffEVr"),
    $63ffb01b27107377$var$load("8uhuz")
]).then(()=>parcelRequire('ar6Ga'));

});

parcelRegister("4vXZ9", function(module, exports) {

let $34989688401e1317$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $34989688401e1317$var$load("6wr18"),
    $34989688401e1317$var$load("ffEVr"),
    $34989688401e1317$var$load("klGUa")
]).then(()=>parcelRequire('8o2bj'));

});

parcelRegister("fyLQb", function(module, exports) {

let $b53f242a74e9c0a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b53f242a74e9c0a3$var$load("fZt2F"),
    $b53f242a74e9c0a3$var$load("6wr18"),
    $b53f242a74e9c0a3$var$load("ffEVr"),
    $b53f242a74e9c0a3$var$load("7EorR"),
    $b53f242a74e9c0a3$var$load("kZjBp")
]).then(()=>parcelRequire('1xLOH'));

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("3AeIf", function(module, exports) {
/**
 * @generated SignedSource<<656b0d44239f7eb3a8ba9659e9762f2f>>
 * @relayHash f18661cc7a1d2d55f19018b453d74e49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62
const $ca580f7b974eac2e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f18661cc7a1d2d55f19018b453d74e49",
            "id": "5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62",
            "metadata": {},
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsOptionsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$ca580f7b974eac2e$var$node.hash = "cc599626e8f53c4256f22a11dfce92c8";
var $ca580f7b974eac2e$export$2e2bcd8739ae039 = $ca580f7b974eac2e$var$node;
module.exports["default"] = $ca580f7b974eac2e$export$2e2bcd8739ae039;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;

});

parcelRegister("aJT7b", function(module, exports) {
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $002d225363d96747$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $002d225363d96747$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $42omo.forwardRef)($002d225363d96747$var$_List);
module.exports["List"] = $002d225363d96747$export$54c2e3dc7acea9f5;

});

parcelRegister("1CdLs", function(module, exports) {
/* expandable-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6mkwk = parcelRequire("6mkwk");


var $jvL0g = parcelRequire("jvL0g");


var $6BXcn = parcelRequire("6BXcn");

const $417a895b4429e145$var$relativeStyles = {
    root: "_kqswh2mm"
}; /**
    * __ExpandableMenuItem__
    *
    * A composable component for nested menu items that can be revealed and hidden by interacting witih the parent menu item.
    *
    * Follows the [disclosure pattern](https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/).
    *
    * Should be used with `ExpandableMenuItemTrigger` as the parent menu item, and children menu items should be wrapped in a `ExpandableMenuItemContent`.
    *
    * Usage example:
    * ```jsx
    * <ExpandableMenuItem>
    *   <ExpandableMenuItemTrigger>Parent menu item</ExpandableMenuItemTrigger>
    *   <ExpandableMenuItemContent>
    *     <ButtonMenuItem>Item 1</ButtonMenuItem>
    *     <ButtonMenuItem>Item 2</ButtonMenuItem>
    *   </ExpandableMenuItemContent>
    * </ExpandableMenuItem>
    * ```
    */ 
const $417a895b4429e145$export$341dea48c30b36ff = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $6mkwk.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jvL0g.MenuListItem), {
                    ref: forwardedRef,
                    testId: testId,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            dropIndicator && $417a895b4429e145$var$relativeStyles.root
                        ]),
                        children: [
                            children,
                            dropIndicator
                        ]
                    })
                })
            })
        })
    });
});
module.exports["ExpandableMenuItem"] = $417a895b4429e145$export$341dea48c30b36ff;

});

parcelRegister("YQCfa", function(module, exports) {
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $aJT7b = parcelRequire("aJT7b");


var $6BXcn = parcelRequire("6BXcn");

const $73667a40c01a69a2$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $73667a40c01a69a2$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $6BXcn.useIsExpanded)();
    const level = (0, $6BXcn.useLevel)();
    const hasExpanded = (0, $42omo.useRef)(false);
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aJT7b.List), {
                ref: forwardedRef,
                xcss: (0, $1bHXt.cx)($73667a40c01a69a2$var$styles.content, !isExpanded && $73667a40c01a69a2$var$styles.collapsedContent),
                children: children
            })
        })
    });
});
module.exports["ExpandableMenuItemContent"] = $73667a40c01a69a2$export$bd680a81504a92e9;

});

parcelRegister("8INvs", function(module, exports) {
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $3hoG4 = parcelRequire("3hoG4");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $dh538 = parcelRequire("dh538");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");


var $6BXcn = parcelRequire("6BXcn");

const $675a107b26f743ab$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $675a107b26f743ab$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $675a107b26f743ab$var$wrapperStyles = {
    root: "_1mmi1txw _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71txw _1hl9glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
const $675a107b26f743ab$var$nestedOpenPopupStylesOld = {
    showProvidedElemBefore: "_v9u71txw _1hl9glyw"
}; // Merge back into the `wrapperStyles` after cleanup
const $675a107b26f743ab$var$nestedOpenPopupStylesNew = {
    showProvidedElemBefore: "_1ddp1txw _pnu5glyw"
};
const $675a107b26f743ab$var$iconStyles = {
    chevron: "_1e0ciw0t _1tz3r0mg",
    providedElemBefore: "_1e0c1xb2",
    providedElemBeforeSelected: "_syazxl6c"
};
const $675a107b26f743ab$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    const chevronElem = /*#__PURE__*/ (0, $l998X.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $675a107b26f743ab$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $675a107b26f743ab$var$iconStyles.providedElemBefore,
                    isSelected && $675a107b26f743ab$var$iconStyles.providedElemBeforeSelected
                ]),
                children: providedElemBefore
            })
        ]
    });
};
const $675a107b26f743ab$export$fe6fe51056867f4d = (0, $3hoG4.default)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $42omo.useId)();
    const onExpansionToggle = (0, $6BXcn.useOnExpansionToggle)();
    const isExpanded = (0, $6BXcn.useIsExpanded)();
    const setIsExpanded = (0, $6BXcn.useSetIsExpanded)();
    const itemRef = (0, $42omo.useRef)(null);
    const handleIconClick = (0, $42omo.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    }); // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)($675a107b26f743ab$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, $l998X.jsx)($675a107b26f743ab$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    }); // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: itemRef,
        className: (0, $gMc0m.default)([
            $675a107b26f743ab$var$wrapperStyles.root,
            providedElemBefore && $675a107b26f743ab$var$wrapperStyles.showProvidedElemBefore,
            (0, $dh538.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? $675a107b26f743ab$var$nestedOpenPopupStylesNew.showProvidedElemBefore : $675a107b26f743ab$var$nestedOpenPopupStylesOld.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            id: id,
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ExpandableMenuItemTrigger"] = $675a107b26f743ab$export$fe6fe51056867f4d;

});

parcelRegister("lfFzM", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $diswb = parcelRequire("diswb");


var $6jrkJ = parcelRequire("6jrkJ");


var $kOBmw = parcelRequire("kOBmw");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $diswb.useQuery)((0, $kOBmw.IsSuperAdmin), {
        skip: !hasSuperAdminClaim
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("kOBmw", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $1f121c69ed56862b$export$b43e9b817e671e28 = (0, $eSUdr.default)`query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id confluence{roles{isSuperAdmin}}}}`;
module.exports["IsSuperAdmin"] = $1f121c69ed56862b$export$b43e9b817e671e28;

});

parcelRegister("2vuKf", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $9zUhf.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $9zUhf.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $9zUhf.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("3qtLb", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $4VJDS = parcelRequire("4VJDS");


var $5Abqh = parcelRequire("5Abqh");


var $6mKj3 = parcelRequire("6mKj3");

const $674e09754a51af28$var$DELAY_HYRATION_ON_HOVER_FF = 'confluence_frontend_delay_hydration_on_hover';
const $674e09754a51af28$export$19ffb24f8071504 = 2;

const $674e09754a51af28$export$10d5dbd9dd81149f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-KKls",
    name: "PageTreeLoader",
    loader: async ()=>(await (parcelRequire("1QQU0"))).PageTree
});

const $674e09754a51af28$export$8ce7795bff922b41 = (0, $jmjWc.LoadableHydrateOnHover)({
    __loadable_id__: "dXqjD",
    name: "PageTreeLoaderOnHover",
    loader: async ()=>(await (parcelRequire("1QQU0"))).PageTree,
    hydrateImmediately: ()=>{
        // If page tree was not successfully rendered on server-side, hydrate immediately otherwise user will see a blank page tree
        return !(0, $5Abqh.checkSSRPartialSuccess)((0, $5Abqh.SSR_PARTIAL_COMPONENT).PageTree);
    }
});
const $674e09754a51af28$export$73500bf5f2e2b0c4 = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $4VJDS.default).getNumber($674e09754a51af28$var$DELAY_HYRATION_ON_HOVER_FF, 0) || 0;
        $[0] = t0;
    } else t0 = $[0];
    const delayHydrationOnHoverTimeout = t0;
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, !(0, $6mKj3.expVal)("confluence_frontend_remove_hydrateonhover_pagetree", "isEnabled", false) && delayHydrationOnHoverTimeout > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($674e09754a51af28$export$8ce7795bff922b41, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($674e09754a51af28$export$10d5dbd9dd81149f, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["ANIMATE_TIME_SEC"] = $674e09754a51af28$export$19ffb24f8071504;
module.exports["PageTreeLoader"] = $674e09754a51af28$export$10d5dbd9dd81149f;
module.exports["PageTreeLoaderOnHover"] = $674e09754a51af28$export$8ce7795bff922b41;
module.exports["PageTree"] = $674e09754a51af28$export$73500bf5f2e2b0c4;

});

parcelRegister("1QQU0", function(module, exports) {

let $1593af111bd6c68f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1593af111bd6c68f$var$load("6wr18"),
    $1593af111bd6c68f$var$load("e4XZ1"),
    $1593af111bd6c68f$var$load("5ppK3"),
    $1593af111bd6c68f$var$load("2Mx5m"),
    $1593af111bd6c68f$var$load("3VMt7"),
    $1593af111bd6c68f$var$load("4mgLr"),
    $1593af111bd6c68f$var$load("19uFC"),
    $1593af111bd6c68f$var$load("28l1x"),
    $1593af111bd6c68f$var$load("ffEVr"),
    $1593af111bd6c68f$var$load("iNa18"),
    $1593af111bd6c68f$var$load("Wowvf"),
    $1593af111bd6c68f$var$load("hhss7"),
    $1593af111bd6c68f$var$load("hogcU"),
    $1593af111bd6c68f$var$load("4UuEP"),
    $1593af111bd6c68f$var$load("dAdaw"),
    $1593af111bd6c68f$var$load("eU9MU"),
    $1593af111bd6c68f$var$load("4izLy"),
    $1593af111bd6c68f$var$load("7EorR"),
    $1593af111bd6c68f$var$load("ltXeo")
]).then(()=>parcelRequire('bbZCI'));

});

parcelRegister("j3kZx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $748c02fb00e52ac9$export$a0aa95d2fbef03e8 = ({ sectionName: sectionName, collapsedByDefault: collapsedByDefault = false, forceExpand: forceExpand = false })=>{
    const [isExpandedManually, setIsExpandedManually] = (0, $42omo.useState)();
    const isDefaultExpanded = (0, $42omo.useMemo)(()=>$748c02fb00e52ac9$var$getExpandedStateBySpace(sectionName, collapsedByDefault), [
        sectionName,
        collapsedByDefault
    ]);
    const hasManualExpansion = isExpandedManually !== undefined;
    const isExpanded = hasManualExpansion ? isExpandedManually : forceExpand || isDefaultExpanded;
    const onExpansionToggle = (0, $42omo.useCallback)((newIsExpanded)=>{
        setIsExpandedManually(newIsExpanded);
        $748c02fb00e52ac9$var$updateExpandedStateBySpace(sectionName, newIsExpanded);
    }, [
        sectionName
    ]);
    return {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    };
};
const $748c02fb00e52ac9$var$getExpandedStateBySpace = (sectionName, collapsedByDefault)=>{
    if ((0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).doesContain((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES)) {
        const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES);
        if (typeof sideNavExpansionStates[sectionName] === 'boolean') return sideNavExpansionStates[sectionName];
    }
    return !collapsedByDefault;
};
const $748c02fb00e52ac9$var$updateExpandedStateBySpace = (sectionName, isExpanded)=>{
    if (!(0, $17wUi.confluenceLocalStorageInstance)) return;
    const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES) || {};
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES, {
        ...sideNavExpansionStates,
        [sectionName]: isExpanded
    });
};
module.exports["useSpacePersistentExpansion"] = $748c02fb00e52ac9$export$a0aa95d2fbef03e8;

});


//# sourceMappingURL=SpaceNavigationContent.ed171d35.js.map
